// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  :root {
    --background: 0 0% 100%;
    --foreground: 240 10% 15%;

    --card: 0 0% 100%;
    --card-foreground: 240 10% 15%;
    --card-glass: 0 0% 100% / 0.8;

    --popover: 0 0% 100%;
    --popover-foreground: 240 10% 15%;

    --primary: 262 83% 58%;
    --primary-foreground: 0 0% 98%;
    --primary-glow: 280 100% 70%;

    --secondary: 240 4.8% 95.9%;
    --secondary-foreground: 240 5.9% 10%;

    --muted: 240 4.8% 95.9%;
    --muted-foreground: 240 3.8% 46.1%;

    --accent: 193 76% 59%;
    --accent-foreground: 0 0% 98%;
    --accent-glow: 193 100% 70%;

    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 0 0% 98%;

    --border: 240 5.9% 90%;
    --input: 240 5.9% 90%;
    --ring: 262 83% 58%;

    --radius: 0.75rem;

    /* Photo sharing specific tokens */
    --gradient-primary: linear-gradient(135deg, hsl(262 83% 58%), hsl(280 100% 70%));
    --gradient-secondary: linear-gradient(135deg, hsl(193 76% 59%), hsl(262 83% 58%));
    --gradient-hero: linear-gradient(135deg, hsl(0 0% 100%) 0%, hsl(262 83% 58% / 0.05) 100%);
    --glass-bg: hsl(0 0% 100% / 0.8);
    --glass-border: hsl(240 5.9% 90%);
    --photo-shadow: 0 25px 50px -12px hsl(262 83% 58% / 0.15);
    --glow-shadow: 0 0 40px hsl(262 83% 58% / 0.2);

    --sidebar-background: 0 0% 98%;
    --sidebar-foreground: 240 5.3% 26.1%;
    --sidebar-primary: 240 5.9% 10%;
    --sidebar-primary-foreground: 0 0% 98%;
    --sidebar-accent: 240 4.8% 95.9%;
    --sidebar-accent-foreground: 240 5.9% 10%;
    --sidebar-border: 220 13% 91%;
    --sidebar-ring: 217.2 91.2% 59.8%;

    /* Body Background Variables - Light Mode Defaults */
    --body-bg: hsl(var(--background));
    --body-bg-gradient: linear-gradient(135deg, hsl(0 0% 100%) 0%, hsl(262 83% 58% / 0.05) 100%);
    --body-bg-cover: transparent;
    --body-font-weight: 400;
    --body-letter-spacing: normal;
    --body-bg-image: none;
    --body-bg-image-size: cover;
  }

  .dark {
    /* Material Design dark theme base - #121212 */
    --background: 0 0% 7%;
    --foreground: 0 0% 95%;

    /* Surface elevation system following Material Design */
    --card: 0 0% 9%;
    /* 1dp elevation = base + 5% white overlay */
    --card-foreground: 0 0% 95%;
    --card-glass: 0 0% 12% / 0.8;
    /* Higher elevation surfaces */

    --popover: 0 0% 11%;
    /* 2dp elevation = base + 7% white overlay */
    --popover-foreground: 0 0% 95%;

    /* Accessible primary colors for dark theme */
    --primary: 270 91% 75%;
    /* Lighter for better accessibility */
    --primary-foreground: 0 0% 10%;
    --primary-glow: 280 100% 80%;

    --secondary: 0 0% 15%;
    /* 3dp elevation = base + 8% white overlay */
    --secondary-foreground: 0 0% 95%;

    --muted: 0 0% 15%;
    --muted-foreground: 0 0% 65%;
    /* Better contrast for muted text */

    --accent: 270 91% 75%;
    --accent-foreground: 0 0% 10%;
    --accent-glow: 280 100% 80%;

    --destructive: 0 70% 50%;
    /* More accessible red */
    --destructive-foreground: 0 0% 95%;

    --border: 0 0% 15%;
    --input: 0 0% 15%;
    --ring: 270 91% 75%;

    /* Material Design elevation surfaces */
    --surface-1dp: 0 0% 9%;
    /* Cards, switches */
    --surface-2dp: 0 0% 11%;
    /* App bars (resting) */
    --surface-3dp: 0 0% 12%;
    /* Refresh indicator, search bar (resting) */
    --surface-4dp: 0 0% 13%;
    /* App bars (scrolled) */
    --surface-6dp: 0 0% 14%;
    /* FAB (resting), snackbars */
    --surface-8dp: 0 0% 15%;
    /* Menus, cards (picked up), switches (thumb) */
    --surface-12dp: 0 0% 16%;
    /* FAB (pressed) */
    --surface-16dp: 0 0% 17%;
    /* Navigation drawer, modal bottom sheets */
    --surface-24dp: 0 0% 18%;
    /* Dialogs */

    /* Photo sharing specific tokens for dark mode */
    --gradient-primary: linear-gradient(135deg, hsl(270 91% 75%), hsl(280 100% 80%));
    --gradient-secondary: linear-gradient(135deg, hsl(270 91% 75%), hsl(260 85% 70%));
    --gradient-hero: linear-gradient(135deg, hsl(0 0% 7%) 0%, hsl(270 91% 75% / 0.1) 100%);
    --glass-bg: hsl(0 0% 12% / 0.4);
    --glass-border: hsl(270 91% 75% / 0.2);
    --photo-shadow: 0 25px 50px -12px hsl(270 91% 75% / 0.25);
    --glow-shadow: 0 0 40px hsl(270 91% 75% / 0.3);

    --sidebar-background: 0 0% 7%;
    --sidebar-foreground: 0 0% 95%;
    --sidebar-primary: 270 91% 75%;
    --sidebar-primary-foreground: 0 0% 10%;
    --sidebar-accent: 0 0% 15%;
    --sidebar-accent-foreground: 0 0% 95%;
    --sidebar-border: 0 0% 15%;
    --sidebar-ring: 270 91% 75%;

    /* Body Background Variables */
    --body-bg: hsl(var(--background));
    --body-bg-gradient: var(--gradient-hero);
    --body-bg-cover: url('/home-background.jpg');
    --body-font-weight: 400;
    --body-letter-spacing: normal;
    --body-bg-image: url('/pattern-dark.png');
    --body-bg-image-size: 140px;
    /* Adjust as needed for pattern density */
  }
  * {
  border-color: hsl(var(--border));
}

  html {
    height: 100%;
    background-color: var(--body-bg);
    background-image: var(--body-bg-gradient);
    scrollbar-width: thin;
    scrollbar-color: hsl(var(--muted-foreground) / 0.3) transparent;

    &:before {
      content: '';
      position: fixed;
      top: 0;
      inset-inline-start: 0;
      inset-inline-end: 0;
      height: 100%;
      z-index: -5;
      background: var(--body-bg-gradient);
      pointer-events: none;
    }

    &:after {
      content: '';
      position: fixed;
      top: 0;
      height: 100%;
      inset-inline-start: 0;
      inset-inline-end: 0;
      z-index: -10;
      background-color: var(--body-bg);
      background-image: var(--body-bg-gradient), var(--body-bg-cover);
      background-repeat: no-repeat;
      background-position: center;
      background-attachment: initial;
      transition: background .2s linear;
      background-size: cover;
      pointer-events: none;
    }
  }

  body {
    /* @apply bg-background text-foreground; - Removing bg-background as it's handled by html/body layers now */
    color: hsl(var(--foreground));
    background: none;
    font-weight: var(--body-font-weight);
    letter-spacing: var(--body-letter-spacing);
    position: relative;
    min-height: 100vh;
    z-index: 1;
    /* Changed from 9999 to avoid stacking issues with modals */

    &:before {
      content: "";
      position: fixed;
      top: 0;
      inset-inline-start: 0;
      inset-inline-end: 0;
      height: 100%;
      background-attachment: initial;
      background-color: transparent;
      background-image: var(--body-bg-image);
      background-size: var(--body-bg-image-size);
      background-repeat: repeat;
      z-index: -5;
      pointer-events: none;
    }

    &:not(.app-init) * {
      transition: none !important;
      animation: none !important;
    }
  }
.\\!container {
  width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 1400px) {

  .\\!container {
    max-width: 1400px !important;
  }

  .container {
    max-width: 1400px;
  }
}
.prose {
  color: var(--tw-prose-body);
  max-width: 65ch;
}
.prose :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-lead);
  font-size: 1.25em;
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.prose :where(a):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-links);
  text-decoration: underline;
  font-weight: 500;
}
.prose :where(strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-bold);
  font-weight: 600;
}
.prose :where(a strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(blockquote strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(thead th strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: decimal;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  padding-inline-start: 1.625em;
}
.prose :where(ol[type="A"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-alpha;
}
.prose :where(ol[type="A" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-alpha;
}
.prose :where(ol[type="I"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-roman;
}
.prose :where(ol[type="i"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-roman;
}
.prose :where(ol[type="I" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-roman;
}
.prose :where(ol[type="i" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-roman;
}
.prose :where(ol[type="1"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: decimal;
}
.prose :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: disc;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  padding-inline-start: 1.625em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker {
  font-weight: 400;
  color: var(--tw-prose-counters);
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker {
  color: var(--tw-prose-bullets);
}
.prose :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.25em;
}
.prose :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-color: var(--tw-prose-hr);
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}
.prose :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 500;
  font-style: italic;
  color: var(--tw-prose-quotes);
  border-inline-start-width: 0.25rem;
  border-inline-start-color: var(--tw-prose-quote-borders);
  quotes: "\\201C""\\201D""\\2018""\\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-inline-start: 1em;
}
.prose :where(blockquote p:first-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: open-quote;
}
.prose :where(blockquote p:last-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: close-quote;
}
.prose :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}
.prose :where(h1 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 900;
  color: inherit;
}
.prose :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}
.prose :where(h2 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 800;
  color: inherit;
}
.prose :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}
.prose :where(h3 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 700;
  color: inherit;
}
.prose :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}
.prose :where(h4 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 700;
  color: inherit;
}
.prose :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  display: block;
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 500;
  font-family: inherit;
  color: var(--tw-prose-kbd);
  box-shadow: 0 0 0 1px var(--tw-prose-kbd-shadows), 0 3px 0 var(--tw-prose-kbd-shadows);
  font-size: 0.875em;
  border-radius: 0.3125rem;
  padding-top: 0.1875em;
  padding-inline-end: 0.375em;
  padding-bottom: 0.1875em;
  padding-inline-start: 0.375em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-code);
  font-weight: 600;
  font-size: 0.875em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: "\`";
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: "\`";
}
.prose :where(a code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(h1 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
  font-size: 0.875em;
}
.prose :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
  font-size: 0.9em;
}
.prose :where(h4 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(blockquote code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(thead th code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-pre-code);
  background-color: var(--tw-prose-pre-bg);
  overflow-x: auto;
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-inline-end: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-inline-start: 1.1428571em;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: inherit;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: none;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: none;
}
.prose :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  width: 100%;
  table-layout: auto;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}
.prose :where(thead):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-th-borders);
}
.prose :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  vertical-align: bottom;
  padding-inline-end: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-inline-start: 0.5714286em;
}
.prose :where(tbody tr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-td-borders);
}
.prose :where(tbody tr:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 0;
}
.prose :where(tbody td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  vertical-align: baseline;
}
.prose :where(tfoot):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-top-width: 1px;
  border-top-color: var(--tw-prose-th-borders);
}
.prose :where(tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  vertical-align: top;
}
.prose :where(th, td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  text-align: start;
}
.prose :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-captions);
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}
.prose {
  --tw-prose-body: #374151;
  --tw-prose-headings: #111827;
  --tw-prose-lead: #4b5563;
  --tw-prose-links: #111827;
  --tw-prose-bold: #111827;
  --tw-prose-counters: #6b7280;
  --tw-prose-bullets: #d1d5db;
  --tw-prose-hr: #e5e7eb;
  --tw-prose-quotes: #111827;
  --tw-prose-quote-borders: #e5e7eb;
  --tw-prose-captions: #6b7280;
  --tw-prose-kbd: #111827;
  --tw-prose-kbd-shadows: rgb(17 24 39 / 10%);
  --tw-prose-code: #111827;
  --tw-prose-pre-code: #e5e7eb;
  --tw-prose-pre-bg: #1f2937;
  --tw-prose-th-borders: #d1d5db;
  --tw-prose-td-borders: #e5e7eb;
  --tw-prose-invert-body: #d1d5db;
  --tw-prose-invert-headings: #fff;
  --tw-prose-invert-lead: #9ca3af;
  --tw-prose-invert-links: #fff;
  --tw-prose-invert-bold: #fff;
  --tw-prose-invert-counters: #9ca3af;
  --tw-prose-invert-bullets: #4b5563;
  --tw-prose-invert-hr: #374151;
  --tw-prose-invert-quotes: #f3f4f6;
  --tw-prose-invert-quote-borders: #374151;
  --tw-prose-invert-captions: #9ca3af;
  --tw-prose-invert-kbd: #fff;
  --tw-prose-invert-kbd-shadows: rgb(255 255 255 / 10%);
  --tw-prose-invert-code: #fff;
  --tw-prose-invert-pre-code: #d1d5db;
  --tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);
  --tw-prose-invert-th-borders: #4b5563;
  --tw-prose-invert-td-borders: #374151;
  font-size: 1rem;
  line-height: 1.75;
}
.prose :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.375em;
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.375em;
}
.prose :where(.prose > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(.prose > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
}
.prose :where(.prose > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.25em;
}
.prose :where(.prose > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
}
.prose :where(.prose > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.25em;
}
.prose :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5em;
  padding-inline-start: 1.625em;
}
.prose :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-top: 0.5714286em;
  padding-inline-end: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-inline-start: 0.5714286em;
}
.prose :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(.prose > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(.prose > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 0;
}
.prose-sm {
  font-size: 0.875rem;
  line-height: 1.7142857;
}
.prose-sm :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.2857143em;
  line-height: 1.5555556;
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-sm :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-inline-start: 1.1111111em;
}
.prose-sm :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 2.1428571em;
  margin-top: 0;
  margin-bottom: 0.8em;
  line-height: 1.2;
}
.prose-sm :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.4285714em;
  margin-top: 1.6em;
  margin-bottom: 0.8em;
  line-height: 1.4;
}
.prose-sm :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.2857143em;
  margin-top: 1.5555556em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}
.prose-sm :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.4285714em;
  margin-bottom: 0.5714286em;
  line-height: 1.4285714;
}
.prose-sm :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-sm :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  border-radius: 0.3125rem;
  padding-top: 0.1428571em;
  padding-inline-end: 0.3571429em;
  padding-bottom: 0.1428571em;
  padding-inline-start: 0.3571429em;
}
.prose-sm :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
}
.prose-sm :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.9em;
}
.prose-sm :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
}
.prose-sm :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  line-height: 1.6666667;
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  border-radius: 0.25rem;
  padding-top: 0.6666667em;
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.2857143em;
  margin-bottom: 0.2857143em;
}
.prose-sm :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4285714em;
}
.prose-sm :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4285714em;
}
.prose-sm :where(.prose-sm > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}
.prose-sm :where(.prose-sm > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
}
.prose-sm :where(.prose-sm > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.1428571em;
}
.prose-sm :where(.prose-sm > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
}
.prose-sm :where(.prose-sm > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.1428571em;
}
.prose-sm :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}
.prose-sm :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
}
.prose-sm :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.2857143em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2.8571429em;
  margin-bottom: 2.8571429em;
}
.prose-sm :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  line-height: 1.5;
}
.prose-sm :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-sm :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-sm :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-top: 0.6666667em;
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-sm :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-sm :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-sm :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  line-height: 1.3333333;
  margin-top: 0.6666667em;
}
.prose-sm :where(.prose-sm > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(.prose-sm > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 0;
}
.prose-lg {
  font-size: 1.125rem;
  line-height: 1.7777778;
}
.prose-lg :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-lg :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.2222222em;
  line-height: 1.4545455;
  margin-top: 1.0909091em;
  margin-bottom: 1.0909091em;
}
.prose-lg :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  padding-inline-start: 1em;
}
.prose-lg :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 2.6666667em;
  margin-top: 0;
  margin-bottom: 0.8333333em;
  line-height: 1;
}
.prose-lg :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.6666667em;
  margin-top: 1.8666667em;
  margin-bottom: 1.0666667em;
  line-height: 1.3333333;
}
.prose-lg :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.3333333em;
  margin-top: 1.6666667em;
  margin-bottom: 0.6666667em;
  line-height: 1.5;
}
.prose-lg :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}
.prose-lg :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-lg :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  border-radius: 0.3125rem;
  padding-top: 0.2222222em;
  padding-inline-end: 0.4444444em;
  padding-bottom: 0.2222222em;
  padding-inline-start: 0.4444444em;
}
.prose-lg :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
}
.prose-lg :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8666667em;
}
.prose-lg :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.875em;
}
.prose-lg :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  line-height: 1.75;
  margin-top: 2em;
  margin-bottom: 2em;
  border-radius: 0.375rem;
  padding-top: 1em;
  padding-inline-end: 1.5em;
  padding-bottom: 1em;
  padding-inline-start: 1.5em;
}
.prose-lg :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-inline-start: 1.5555556em;
}
.prose-lg :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-inline-start: 1.5555556em;
}
.prose-lg :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.6666667em;
  margin-bottom: 0.6666667em;
}
.prose-lg :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4444444em;
}
.prose-lg :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4444444em;
}
.prose-lg :where(.prose-lg > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-lg :where(.prose-lg > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
}
.prose-lg :where(.prose-lg > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.3333333em;
}
.prose-lg :where(.prose-lg > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
}
.prose-lg :where(.prose-lg > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.3333333em;
}
.prose-lg :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-lg :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-lg :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
}
.prose-lg :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.6666667em;
  padding-inline-start: 1.5555556em;
}
.prose-lg :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 3.1111111em;
  margin-bottom: 3.1111111em;
}
.prose-lg :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  line-height: 1.5;
}
.prose-lg :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0.75em;
  padding-bottom: 0.75em;
  padding-inline-start: 0.75em;
}
.prose-lg :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-lg :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-lg :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-top: 0.75em;
  padding-inline-end: 0.75em;
  padding-bottom: 0.75em;
  padding-inline-start: 0.75em;
}
.prose-lg :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-lg :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-lg :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-lg :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  line-height: 1.5;
  margin-top: 1em;
}
.prose-lg :where(.prose-lg > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(.prose-lg > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 0;
}
.prose-invert {
  --tw-prose-body: var(--tw-prose-invert-body);
  --tw-prose-headings: var(--tw-prose-invert-headings);
  --tw-prose-lead: var(--tw-prose-invert-lead);
  --tw-prose-links: var(--tw-prose-invert-links);
  --tw-prose-bold: var(--tw-prose-invert-bold);
  --tw-prose-counters: var(--tw-prose-invert-counters);
  --tw-prose-bullets: var(--tw-prose-invert-bullets);
  --tw-prose-hr: var(--tw-prose-invert-hr);
  --tw-prose-quotes: var(--tw-prose-invert-quotes);
  --tw-prose-quote-borders: var(--tw-prose-invert-quote-borders);
  --tw-prose-captions: var(--tw-prose-invert-captions);
  --tw-prose-kbd: var(--tw-prose-invert-kbd);
  --tw-prose-kbd-shadows: var(--tw-prose-invert-kbd-shadows);
  --tw-prose-code: var(--tw-prose-invert-code);
  --tw-prose-pre-code: var(--tw-prose-invert-pre-code);
  --tw-prose-pre-bg: var(--tw-prose-invert-pre-bg);
  --tw-prose-th-borders: var(--tw-prose-invert-th-borders);
  --tw-prose-td-borders: var(--tw-prose-invert-td-borders);
}
/* Ensure links in prose content are clickable and styled */
.prose a {
  cursor: pointer;
  color: hsl(var(--primary));
  text-decoration-line: underline;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.prose a:hover {
  color: hsl(var(--primary) / 0.8);
  text-decoration-line: none;
}
.prose a:visited {
  color: hsl(var(--primary) / 0.7);
}
/* Enhanced prose table styling */
.prose table {
  width: 100%;
  border-collapse: collapse;
  border-width: 1px;
  border-color: hsl(var(--border));
}
.prose thead {
  background-color: hsl(var(--muted) / 0.5);
}
.prose th {
  border-width: 1px;
  border-color: hsl(var(--border));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: left;
  font-weight: 600;
}
.prose td {
  border-width: 1px;
  border-color: hsl(var(--border));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.prose tbody tr:hover {
  background-color: hsl(var(--muted) / 0.3);
}
/* Heading styles */
.prose h1,
  .prose h2,
  .prose h3,
  .prose h4 {
    scroll-margin-top: 5rem; /* offset for fixed top nav (56px) + breathing room */
  }
.prose h1 {
  margin-bottom: 1rem;
  margin-top: 1.5rem;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
}
.prose h2 {
  margin-bottom: 0.75rem;
  margin-top: 1.25rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 700;
}
.prose h3 {
  margin-bottom: 0.5rem;
  margin-top: 1rem;
  font-weight: 600;
}
.prose h4 {
  margin-bottom: 0.5rem;
  margin-top: 0.75rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
}
/* List styles */
.prose ul {
  margin-bottom: 1rem;
  list-style-type: disc;
  padding-left: 1.5rem;
}
.prose ol {
  margin-bottom: 1rem;
  list-style-type: decimal;
  padding-left: 1.5rem;
}
.prose li {
  margin-bottom: 0.25rem;
}
/* Code blocks */
.prose code {
  border-radius: 0.25rem;
  background-color: hsl(var(--muted));
  padding-left: 0.375rem;
  padding-right: 0.375rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: hsl(var(--foreground));
}
/* Typography plugin decorates inline code with literal backticks — disable for rendered markdown */
.prose :where(code):not(:where(pre code))::before,
  .prose :where(code):not(:where(pre code))::after {
    content: none;
  }
.prose pre {
  margin-bottom: 1rem;
  overflow-x: auto;
  border-radius: var(--radius);
  background-color: hsl(var(--muted));
  padding: 1rem;
  color: hsl(var(--foreground));
}
.prose pre code {
  background-color: transparent;
  padding: 0px;
  font-weight: 400;
  color: hsl(var(--foreground));
}
/* Blockquotes */
.prose blockquote {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-left-width: 4px;
  border-color: hsl(var(--primary));
  padding-left: 1rem;
  font-style: italic;
}
/* Paragraphs */
.prose p {
  margin-bottom: 1rem;
}
/* Horizontal rules */
.prose hr {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  border-top-width: 1px;
  border-color: hsl(var(--border));
}
/* Strong/Bold */
.prose strong {
  font-weight: 700;
}
/* Emphasis/Italic */
.prose em {
  font-style: italic;
}
/* Force Vidstack video to use object-contain for full video display */
[data-media-player] video {
    -o-object-fit: contain !important;
       object-fit: contain !important;
    -o-object-position: center !important;
       object-position: center !important;
    max-width: 100% !important;
    max-height: 100% !important;
    width: 100% !important;
    height: 100% !important;
  }
/* Constrain video player to viewport */
[data-media-player] {
    max-width: 100% !important;
    max-height: 100% !important;
  }
/* Email Widget Overrides (Design View) */
/* Fix for "font-size: 0" hack in email templates causing invisible text in editor */
/* 
     Reset email table structure for Editor View 
     - Makes the gray structural background transparent
     - Allows widgets to take full width of their container in the editor
  */
/* RJSF Textarea Dark Mode Fix */
/* Textareas inherit browser defaults which show white in dark mode */
textarea {
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
}
.dark textarea {
    background-color: rgba(0, 0, 0, 0.5);
  }
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-12 {
  bottom: -3rem;
}
.-bottom-3 {
  bottom: -0.75rem;
}
.-left-1 {
  left: -0.25rem;
}
.-left-12 {
  left: -3rem;
}
.-left-3 {
  left: -0.75rem;
}
.-right-0\\.5 {
  right: -0.125rem;
}
.-right-1 {
  right: -0.25rem;
}
.-right-12 {
  right: -3rem;
}
.-right-2 {
  right: -0.5rem;
}
.-right-3 {
  right: -0.75rem;
}
.-top-0\\.5 {
  top: -0.125rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-12 {
  top: -3rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-3 {
  top: -0.75rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-16 {
  bottom: 4rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-24 {
  bottom: 6rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-8 {
  bottom: 2rem;
}
.left-0 {
  left: 0px;
}
.left-0\\.5 {
  left: 0.125rem;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-1\\/3 {
  left: 33.333333%;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-2\\/3 {
  left: 66.666667%;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-\\[11px\\] {
  left: 11px;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-0\\.5 {
  right: 0.125rem;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\.5 {
  right: 0.375rem;
}
.right-14 {
  right: 3.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-2\\.5 {
  right: 0.625rem;
}
.right-24 {
  right: 6rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-1\\/3 {
  top: 33.333333%;
}
.top-14 {
  top: 3.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-2\\/3 {
  top: 66.666667%;
}
.top-24 {
  top: 6rem;
}
.top-3 {
  top: 0.75rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[1px\\] {
  top: 1px;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[60\\%\\] {
  top: 60%;
}
.top-\\[calc\\(50\\%-1\\.25rem\\)\\] {
  top: calc(50% - 1.25rem);
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[-1\\] {
  z-index: -1;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[200\\] {
  z-index: 200;
}
.z-\\[2200\\] {
  z-index: 2200;
}
.z-\\[250\\] {
  z-index: 250;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[3\\] {
  z-index: 3;
}
.z-\\[4\\] {
  z-index: 4;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[99999\\] {
  z-index: 99999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-9 {
  grid-column: span 9 / span 9;
}
.col-span-full {
  grid-column: 1 / -1;
}
.\\!m-0 {
  margin: 0px !important;
}
.-m-3 {
  margin: -0.75rem;
}
.m-0 {
  margin: 0px;
}
.m-1 {
  margin: 0.25rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-3 {
  margin: 0.75rem;
}
.m-4 {
  margin: 1rem;
}
.m-6 {
  margin: 1.5rem;
}
.m-8 {
  margin: 2rem;
}
.m-auto {
  margin: auto;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.-my-1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3\\.5 {
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-\\[1px\\] {
  margin-top: 1px;
  margin-bottom: 1px;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-ml-2 {
  margin-left: -0.5rem;
}
.-ml-4 {
  margin-left: -1rem;
}
.-ml-\\[1px\\] {
  margin-left: -1px;
}
.-mt-4 {
  margin-top: -1rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-0 {
  margin-left: 0px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-12 {
  margin-left: 3rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-7 {
  margin-left: 1.75rem;
}
.ml-\\[11px\\] {
  margin-left: 11px;
}
.ml-auto {
  margin-left: auto;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-2\\.5 {
  margin-right: 0.625rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[-2px\\] {
  margin-top: -2px;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mt-auto {
  margin-top: auto;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.\\!inline {
  display: inline !important;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/9\\] {
  aspect-ratio: 16/9;
}
.aspect-\\[9\\/16\\] {
  aspect-ratio: 9/16;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-1\\/2 {
  height: 50%;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-2\\/3 {
  height: 66.666667%;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[3rem\\] {
  height: 3rem;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[667px\\] {
  height: 667px;
}
.h-\\[70vh\\] {
  height: 70vh;
}
.h-\\[75vh\\] {
  height: 75vh;
}
.h-\\[80vh\\] {
  height: 80vh;
}
.h-\\[85vh\\] {
  height: 85vh;
}
.h-\\[90vh\\] {
  height: 90vh;
}
.h-\\[calc\\(100svh-4rem\\)\\] {
  height: calc(100svh - 4rem);
}
.h-\\[calc\\(100vh-100px\\)\\] {
  height: calc(100vh - 100px);
}
.h-\\[calc\\(100vh-12rem\\)\\] {
  height: calc(100vh - 12rem);
}
.h-\\[calc\\(100vh-140px\\)\\] {
  height: calc(100vh - 140px);
}
.h-\\[calc\\(100vh-200px\\)\\] {
  height: calc(100vh - 200px);
}
.h-\\[calc\\(100vh-3\\.5rem\\)\\] {
  height: calc(100vh - 3.5rem);
}
.h-\\[calc\\(100vh-4rem\\)\\] {
  height: calc(100vh - 4rem);
}
.h-\\[calc\\(100vh-64px\\)\\] {
  height: calc(100vh - 64px);
}
.h-\\[calc\\(100vh-8rem\\)\\] {
  height: calc(100vh - 8rem);
}
.h-\\[inherit\\] {
  height: inherit;
}
.h-\\[min\\(720px\\2c calc\\(100vh-10rem\\)\\)\\] {
  height: min(720px, calc(100vh - 10rem));
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\] {
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
  height: var(--radix-select-trigger-height);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.h-svh {
  height: 100svh;
}
.max-h-16 {
  max-height: 4rem;
}
.max-h-24 {
  max-height: 6rem;
}
.max-h-28 {
  max-height: 7rem;
}
.max-h-32 {
  max-height: 8rem;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[100dvh\\] {
  max-height: 100dvh;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[240px\\] {
  max-height: 240px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[360px\\] {
  max-height: 360px;
}
.max-h-\\[4\\.5em\\] {
  max-height: 4.5em;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[50\\%\\] {
  max-height: 50%;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[600px\\] {
  max-height: 600px;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[700px\\] {
  max-height: 700px;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[92vh\\] {
  max-height: 92vh;
}
.max-h-\\[calc\\(100vh-8rem\\)\\] {
  max-height: calc(100vh - 8rem);
}
.max-h-\\[min\\(70vh\\2c 480px\\)\\] {
  max-height: min(70vh, 480px);
}
.max-h-full {
  max-height: 100%;
}
.max-h-none {
  max-height: none;
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-8 {
  min-height: 2rem;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[180px\\] {
  min-height: 180px;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[20px\\] {
  min-height: 20px;
}
.min-h-\\[250px\\] {
  min-height: 250px;
}
.min-h-\\[28px\\] {
  min-height: 28px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[36px\\] {
  min-height: 36px;
}
.min-h-\\[3rem\\] {
  min-height: 3rem;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[44px\\] {
  min-height: 44px;
}
.min-h-\\[450px\\] {
  min-height: 450px;
}
.min-h-\\[5\\.5rem\\] {
  min-height: 5.5rem;
}
.min-h-\\[50\\%\\] {
  min-height: 50%;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-\\[50px\\] {
  min-height: 50px;
}
.min-h-\\[600px\\] {
  min-height: 600px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[7\\.5rem\\] {
  min-height: 7.5rem;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[calc\\(100vh-8rem\\)\\] {
  min-height: calc(100vh - 8rem);
}
.min-h-\\[min\\(380px\\2c 50vh\\)\\] {
  min-height: min(380px, 50vh);
}
.min-h-\\[min\\(420px\\2c 55vh\\)\\] {
  min-height: min(420px, 55vh);
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.min-h-svh {
  min-height: 100svh;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[--sidebar-width\\] {
  width: var(--sidebar-width);
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[150\\%\\] {
  width: 150%;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[350px\\] {
  width: 350px;
}
.w-\\[375px\\] {
  width: 375px;
}
.w-\\[380px\\] {
  width: 380px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[420px\\] {
  width: 420px;
}
.w-\\[44px\\] {
  width: 44px;
}
.w-\\[450px\\] {
  width: 450px;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[85vw\\] {
  width: 85vw;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[90vw\\] {
  width: 90vw;
}
.w-\\[var\\(--radix-dropdown-menu-trigger-width\\)\\] {
  width: var(--radix-dropdown-menu-trigger-width);
}
.w-\\[var\\(--radix-popover-trigger-width\\)\\] {
  width: var(--radix-popover-trigger-width);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: -moz-max-content;
  width: max-content;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-5 {
  min-width: 1.25rem;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[12px\\] {
  min-width: 12px;
}
.min-w-\\[12rem\\] {
  min-width: 12rem;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[320px\\] {
  min-width: 320px;
}
.min-w-\\[44px\\] {
  min-width: 44px;
}
.min-w-\\[4rem\\] {
  min-width: 4rem;
}
.min-w-\\[60px\\] {
  min-width: 60px;
}
.min-w-\\[6rem\\] {
  min-width: 6rem;
}
.min-w-\\[7rem\\] {
  min-width: 7rem;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
  min-width: var(--radix-select-trigger-width);
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: -moz-max-content;
  min-width: max-content;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[--skeleton-width\\] {
  max-width: var(--skeleton-width);
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[100vw\\] {
  max-width: 100vw;
}
.max-w-\\[10rem\\] {
  max-width: 10rem;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[1400px\\] {
  max-width: 1400px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[1600px\\] {
  max-width: 1600px;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[48px\\] {
  max-width: 48px;
}
.max-w-\\[50vw\\] {
  max-width: 50vw;
}
.max-w-\\[60px\\] {
  max-width: 60px;
}
.max-w-\\[66px\\] {
  max-width: 66px;
}
.max-w-\\[7rem\\] {
  max-width: 7rem;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[90vw\\] {
  max-width: 90vw;
}
.max-w-\\[95\\%\\] {
  max-width: 95%;
}
.max-w-\\[95vw\\] {
  max-width: 95vw;
}
.max-w-\\[96vw\\] {
  max-width: 96vw;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-max {
  max-width: -moz-max-content;
  max-width: max-content;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-screen-xl {
  max-width: 1280px;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-\\[0_0_100\\%\\] {
  flex: 0 0 100%;
}
.flex-\\[2\\] {
  flex: 2;
}
.flex-none {
  flex: none;
}
.flex-shrink {
  flex-shrink: 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.grow-0 {
  flex-grow: 0;
}
.basis-0 {
  flex-basis: 0px;
}
.basis-\\[60\\%\\] {
  flex-basis: 60%;
}
.basis-full {
  flex-basis: 100%;
}
.caption-bottom {
  caption-side: bottom;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-bottom-left {
  transform-origin: bottom left;
}
.origin-bottom-right {
  transform-origin: bottom right;
}
.origin-right {
  transform-origin: right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-px {
  --tw-translate-x: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-3 {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6 {
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-px {
  --tw-translate-x: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-8 {
  --tw-translate-y: 2rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-125 {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.99\\] {
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.01\\] {
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.02\\] {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-col-resize {
  cursor: col-resize;
}
.cursor-crosshair {
  cursor: crosshair;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-move {
  cursor: move;
}
.cursor-ne-resize {
  cursor: ne-resize;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-nw-resize {
  cursor: nw-resize;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-se-resize {
  cursor: se-resize;
}
.cursor-sw-resize {
  cursor: sw-resize;
}
.cursor-zoom-in {
  cursor: zoom-in;
}
.touch-none {
  touch-action: none;
}
.touch-manipulation {
  touch-action: manipulation;
}
.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.select-all {
  -webkit-user-select: all;
     -moz-user-select: all;
          user-select: all;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.snap-y {
  scroll-snap-type: y var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-start {
  scroll-snap-align: start;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-flow-col {
  grid-auto-flow: column;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-\\[10rem_1fr\\] {
  grid-template-columns: 10rem 1fr;
}
.grid-cols-\\[160px_1fr\\] {
  grid-template-columns: 160px 1fr;
}
.grid-cols-\\[1fr_1fr_auto\\] {
  grid-template-columns: 1fr 1fr auto;
}
.grid-cols-\\[1fr_80px_auto\\] {
  grid-template-columns: 1fr 80px auto;
}
.grid-cols-\\[1fr_auto\\] {
  grid-template-columns: 1fr auto;
}
.grid-cols-\\[8\\.5rem_1fr\\] {
  grid-template-columns: 8.5rem 1fr;
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(250px\\2c 350px\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(250px,350px));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(250px\\2c 380px\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(250px,380px));
}
.grid-rows-3 {
  grid-template-rows: repeat(3, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-px {
  gap: 1px;
}
.gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-x-6 {
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}
.gap-x-8 {
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
.gap-y-0 {
  row-gap: 0px;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-amber-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-divide-opacity, 1));
}
.divide-rose-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.overscroll-y-contain {
  overscroll-behavior-y: contain;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[2rem\\] {
  border-radius: 2rem;
}
.rounded-\\[inherit\\] {
  border-radius: inherit;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: var(--radius);
}
.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-lg {
  border-bottom-right-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.rounded-b-md {
  border-bottom-right-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-md {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-\\[10px\\] {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-lg {
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
}
.rounded-t-md {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-top-right-radius: calc(var(--radius) - 2px);
}
.rounded-bl {
  border-bottom-left-radius: 0.25rem;
}
.rounded-bl-md {
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.rounded-br-md {
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.rounded-tl-sm {
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-8 {
  border-width: 8px;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-l-8 {
  border-left-width: 8px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-\\[--color-border\\] {
  border-color: var(--color-border);
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-200\\/60 {
  border-color: rgb(253 230 138 / 0.6);
}
.border-amber-200\\/80 {
  border-color: rgb(253 230 138 / 0.8);
}
.border-amber-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-400\\/40 {
  border-color: rgb(251 191 36 / 0.4);
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/20 {
  border-color: rgb(245 158 11 / 0.2);
}
.border-background {
  border-color: hsl(var(--background));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/50 {
  border-color: rgb(191 219 254 / 0.5);
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-300\\/50 {
  border-color: rgb(147 197 253 / 0.5);
}
.border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-blue-400\\/40 {
  border-color: rgb(96 165 250 / 0.4);
}
.border-blue-400\\/50 {
  border-color: rgb(96 165 250 / 0.5);
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-500\\/20 {
  border-color: rgb(59 130 246 / 0.2);
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-border {
  border-color: hsl(var(--border));
}
.border-border\\/30 {
  border-color: hsl(var(--border) / 0.3);
}
.border-border\\/40 {
  border-color: hsl(var(--border) / 0.4);
}
.border-border\\/50 {
  border-color: hsl(var(--border) / 0.5);
}
.border-border\\/60 {
  border-color: hsl(var(--border) / 0.6);
}
.border-current {
  border-color: currentColor;
}
.border-cyan-400\\/40 {
  border-color: rgb(34 211 238 / 0.4);
}
.border-cyan-400\\/50 {
  border-color: rgb(34 211 238 / 0.5);
}
.border-cyan-500\\/50 {
  border-color: rgb(6 182 212 / 0.5);
}
.border-destructive {
  border-color: hsl(var(--destructive));
}
.border-destructive\\/20 {
  border-color: hsl(var(--destructive) / 0.2);
}
.border-destructive\\/30 {
  border-color: hsl(var(--destructive) / 0.3);
}
.border-destructive\\/50 {
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-500\\/20 {
  border-color: rgb(16 185 129 / 0.2);
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/50 {
  border-color: rgb(229 231 235 / 0.5);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400\\/40 {
  border-color: rgb(156 163 175 / 0.4);
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-gray-700\\/20 {
  border-color: rgb(55 65 81 / 0.2);
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-green-400\\/40 {
  border-color: rgb(74 222 128 / 0.4);
}
.border-green-400\\/50 {
  border-color: rgb(74 222 128 / 0.5);
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-green-500\\/20 {
  border-color: rgb(34 197 94 / 0.2);
}
.border-green-500\\/30 {
  border-color: rgb(34 197 94 / 0.3);
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-600 {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-input {
  border-color: hsl(var(--input));
}
.border-input\\/60 {
  border-color: hsl(var(--input) / 0.6);
}
.border-muted {
  border-color: hsl(var(--muted));
}
.border-muted-foreground\\/25 {
  border-color: hsl(var(--muted-foreground) / 0.25);
}
.border-muted-foreground\\/30 {
  border-color: hsl(var(--muted-foreground) / 0.3);
}
.border-muted\\/30 {
  border-color: hsl(var(--muted) / 0.3);
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-pink-600\\/20 {
  border-color: rgb(219 39 119 / 0.2);
}
.border-primary {
  border-color: hsl(var(--primary));
}
.border-primary-foreground\\/20 {
  border-color: hsl(var(--primary-foreground) / 0.2);
}
.border-primary\\/10 {
  border-color: hsl(var(--primary) / 0.1);
}
.border-primary\\/20 {
  border-color: hsl(var(--primary) / 0.2);
}
.border-primary\\/30 {
  border-color: hsl(var(--primary) / 0.3);
}
.border-primary\\/40 {
  border-color: hsl(var(--primary) / 0.4);
}
.border-primary\\/5 {
  border-color: hsl(var(--primary) / 0.05);
}
.border-primary\\/50 {
  border-color: hsl(var(--primary) / 0.5);
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-200\\/50 {
  border-color: rgb(233 213 255 / 0.5);
}
.border-purple-400\\/20 {
  border-color: rgb(192 132 252 / 0.2);
}
.border-purple-400\\/40 {
  border-color: rgb(192 132 252 / 0.4);
}
.border-purple-400\\/50 {
  border-color: rgb(192 132 252 / 0.5);
}
.border-purple-500\\/10 {
  border-color: rgb(168 85 247 / 0.1);
}
.border-purple-500\\/20 {
  border-color: rgb(168 85 247 / 0.2);
}
.border-purple-500\\/30 {
  border-color: rgb(168 85 247 / 0.3);
}
.border-purple-500\\/40 {
  border-color: rgb(168 85 247 / 0.4);
}
.border-purple-500\\/50 {
  border-color: rgb(168 85 247 / 0.5);
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400\\/50 {
  border-color: rgb(248 113 113 / 0.5);
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/20 {
  border-color: rgb(239 68 68 / 0.2);
}
.border-red-500\\/30 {
  border-color: rgb(239 68 68 / 0.3);
}
.border-red-500\\/50 {
  border-color: rgb(239 68 68 / 0.5);
}
.border-red-600\\/20 {
  border-color: rgb(220 38 38 / 0.2);
}
.border-red-600\\/30 {
  border-color: rgb(220 38 38 / 0.3);
}
.border-rose-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-600\\/20 {
  border-color: rgb(225 29 72 / 0.2);
}
.border-sidebar-border {
  border-color: hsl(var(--sidebar-border));
}
.border-sky-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity, 1));
}
.border-sky-200 {
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/30 {
  border-color: rgb(226 232 240 / 0.3);
}
.border-slate-200\\/50 {
  border-color: rgb(226 232 240 / 0.5);
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-300\\/30 {
  border-color: rgb(203 213 225 / 0.3);
}
.border-slate-300\\/50 {
  border-color: rgb(203 213 225 / 0.5);
}
.border-slate-400 {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.border-teal-500\\/30 {
  border-color: rgb(20 184 166 / 0.3);
}
.border-teal-600\\/30 {
  border-color: rgb(13 148 136 / 0.3);
}
.border-transparent {
  border-color: transparent;
}
.border-violet-300 {
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.border-violet-500\\/20 {
  border-color: rgb(139 92 246 / 0.2);
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/30 {
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/5 {
  border-color: rgb(255 255 255 / 0.05);
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-200\\/50 {
  border-color: rgb(254 240 138 / 0.5);
}
.border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.border-yellow-500\\/20 {
  border-color: rgb(234 179 8 / 0.2);
}
.border-zinc-800 {
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity, 1));
}
.border-b-transparent {
  border-bottom-color: transparent;
}
.border-l-indigo-600 {
  --tw-border-opacity: 1;
  border-left-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-l-primary {
  border-left-color: hsl(var(--primary));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-l-white {
  --tw-border-opacity: 1;
  border-left-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-t-blue-500 {
  --tw-border-opacity: 1;
  border-top-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-t-transparent {
  border-top-color: transparent;
}
.border-t-white {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-\\[--color-bg\\] {
  background-color: var(--color-bg);
}
.bg-accent {
  background-color: hsl(var(--accent));
}
.bg-accent\\/5 {
  background-color: hsl(var(--accent) / 0.05);
}
.bg-accent\\/50 {
  background-color: hsl(var(--accent) / 0.5);
}
.bg-accent\\/70 {
  background-color: hsl(var(--accent) / 0.7);
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-200\\/80 {
  background-color: rgb(253 230 138 / 0.8);
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/30 {
  background-color: rgb(255 251 235 / 0.3);
}
.bg-amber-50\\/90 {
  background-color: rgb(255 251 235 / 0.9);
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-background {
  background-color: hsl(var(--background));
}
.bg-background\\/40 {
  background-color: hsl(var(--background) / 0.4);
}
.bg-background\\/50 {
  background-color: hsl(var(--background) / 0.5);
}
.bg-background\\/80 {
  background-color: hsl(var(--background) / 0.8);
}
.bg-background\\/90 {
  background-color: hsl(var(--background) / 0.9);
}
.bg-background\\/95 {
  background-color: hsl(var(--background) / 0.95);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/0 {
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45 {
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/5 {
  background-color: rgb(0 0 0 / 0.05);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/75 {
  background-color: rgb(0 0 0 / 0.75);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/90 {
  background-color: rgb(0 0 0 / 0.9);
}
.bg-black\\/95 {
  background-color: rgb(0 0 0 / 0.95);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-100\\/40 {
  background-color: rgb(219 234 254 / 0.4);
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/10 {
  background-color: rgb(239 246 255 / 0.1);
}
.bg-blue-50\\/20 {
  background-color: rgb(239 246 255 / 0.2);
}
.bg-blue-50\\/50 {
  background-color: rgb(239 246 255 / 0.5);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/10 {
  background-color: rgb(59 130 246 / 0.1);
}
.bg-blue-500\\/15 {
  background-color: rgb(59 130 246 / 0.15);
}
.bg-blue-500\\/20 {
  background-color: rgb(59 130 246 / 0.2);
}
.bg-blue-500\\/90 {
  background-color: rgb(59 130 246 / 0.9);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-border {
  background-color: hsl(var(--border));
}
.bg-card {
  background-color: hsl(var(--card));
}
.bg-card\\/20 {
  background-color: hsl(var(--card) / 0.2);
}
.bg-card\\/30 {
  background-color: hsl(var(--card) / 0.3);
}
.bg-card\\/40 {
  background-color: hsl(var(--card) / 0.4);
}
.bg-card\\/50 {
  background-color: hsl(var(--card) / 0.5);
}
.bg-current {
  background-color: currentColor;
}
.bg-cyan-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.bg-destructive {
  background-color: hsl(var(--destructive));
}
.bg-destructive\\/10 {
  background-color: hsl(var(--destructive) / 0.1);
}
.bg-destructive\\/5 {
  background-color: hsl(var(--destructive) / 0.05);
}
.bg-destructive\\/80 {
  background-color: hsl(var(--destructive) / 0.8);
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-foreground {
  background-color: hsl(var(--foreground));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-100\\/50 {
  background-color: rgb(243 244 246 / 0.5);
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/10 {
  background-color: rgb(249 250 251 / 0.1);
}
.bg-gray-50\\/30 {
  background-color: rgb(249 250 251 / 0.3);
}
.bg-gray-50\\/50 {
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-800\\/50 {
  background-color: rgb(31 41 55 / 0.5);
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-gray-900\\/40 {
  background-color: rgb(17 24 39 / 0.4);
}
.bg-gray-900\\/50 {
  background-color: rgb(17 24 39 / 0.5);
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/10 {
  background-color: rgb(34 197 94 / 0.1);
}
.bg-green-500\\/15 {
  background-color: rgb(34 197 94 / 0.15);
}
.bg-green-500\\/90 {
  background-color: rgb(34 197 94 / 0.9);
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-400\\/90 {
  background-color: rgb(129 140 248 / 0.9);
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/50 {
  background-color: rgb(238 242 255 / 0.5);
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-muted {
  background-color: hsl(var(--muted));
}
.bg-muted-foreground\\/30 {
  background-color: hsl(var(--muted-foreground) / 0.3);
}
.bg-muted\\/10 {
  background-color: hsl(var(--muted) / 0.1);
}
.bg-muted\\/20 {
  background-color: hsl(var(--muted) / 0.2);
}
.bg-muted\\/30 {
  background-color: hsl(var(--muted) / 0.3);
}
.bg-muted\\/40 {
  background-color: hsl(var(--muted) / 0.4);
}
.bg-muted\\/5 {
  background-color: hsl(var(--muted) / 0.05);
}
.bg-muted\\/50 {
  background-color: hsl(var(--muted) / 0.5);
}
.bg-muted\\/60 {
  background-color: hsl(var(--muted) / 0.6);
}
.bg-muted\\/90 {
  background-color: hsl(var(--muted) / 0.9);
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-500\\/10 {
  background-color: rgb(249 115 22 / 0.1);
}
.bg-orange-500\\/15 {
  background-color: rgb(249 115 22 / 0.15);
}
.bg-popover {
  background-color: hsl(var(--popover));
}
.bg-primary {
  background-color: hsl(var(--primary));
}
.bg-primary\\/10 {
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20 {
  background-color: hsl(var(--primary) / 0.2);
}
.bg-primary\\/40 {
  background-color: hsl(var(--primary) / 0.4);
}
.bg-primary\\/5 {
  background-color: hsl(var(--primary) / 0.05);
}
.bg-primary\\/70 {
  background-color: hsl(var(--primary) / 0.7);
}
.bg-primary\\/80 {
  background-color: hsl(var(--primary) / 0.8);
}
.bg-primary\\/95 {
  background-color: hsl(var(--primary) / 0.95);
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-400\\/10 {
  background-color: rgb(192 132 252 / 0.1);
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50\\/30 {
  background-color: rgb(250 245 255 / 0.3);
}
.bg-purple-50\\/50 {
  background-color: rgb(250 245 255 / 0.5);
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/10 {
  background-color: rgb(168 85 247 / 0.1);
}
.bg-purple-500\\/20 {
  background-color: rgb(168 85 247 / 0.2);
}
.bg-purple-500\\/30 {
  background-color: rgb(168 85 247 / 0.3);
}
.bg-purple-500\\/5 {
  background-color: rgb(168 85 247 / 0.05);
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10 {
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/15 {
  background-color: rgb(239 68 68 / 0.15);
}
.bg-red-500\\/20 {
  background-color: rgb(239 68 68 / 0.2);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-600\\/15 {
  background-color: rgb(220 38 38 / 0.15);
}
.bg-red-600\\/80 {
  background-color: rgb(220 38 38 / 0.8);
}
.bg-red-900\\/20 {
  background-color: rgb(127 29 29 / 0.2);
}
.bg-rose-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-secondary {
  background-color: hsl(var(--secondary));
}
.bg-sidebar {
  background-color: hsl(var(--sidebar-background));
}
.bg-sidebar-border {
  background-color: hsl(var(--sidebar-border));
}
.bg-sky-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/30 {
  background-color: rgb(248 250 252 / 0.3);
}
.bg-slate-50\\/50 {
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.bg-slate-500\\/15 {
  background-color: rgb(100 116 139 / 0.15);
}
.bg-slate-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-teal-500\\/10 {
  background-color: rgb(20 184 166 / 0.1);
}
.bg-teal-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1));
}
.bg-teal-600\\/20 {
  background-color: rgb(13 148 136 / 0.2);
}
.bg-tiktok-red {
  --tw-bg-opacity: 1;
  background-color: rgb(238 29 82 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-violet-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-100\\/50 {
  background-color: rgb(254 249 195 / 0.5);
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400\\/50 {
  background-color: rgb(250 204 21 / 0.5);
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500\\/10 {
  background-color: rgb(234 179 8 / 0.1);
}
.bg-yellow-500\\/15 {
  background-color: rgb(234 179 8 / 0.15);
}
.bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.bg-zinc-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}
.bg-zinc-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity, 1));
}
.bg-zinc-950\\/50 {
  background-color: rgb(9 9 11 / 0.5);
}
.bg-gradient-primary {
  background-image: var(--gradient-primary);
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-amber-400 {
  --tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500\\/20 {
  --tw-gradient-from: rgb(245 158 11 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-background {
  --tw-gradient-from: hsl(var(--background)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--background) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/60 {
  --tw-gradient-from: rgb(0 0 0 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/70 {
  --tw-gradient-from: rgb(0 0 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/80 {
  --tw-gradient-from: rgb(0 0 0 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-100 {
  --tw-gradient-from: #dbeafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 234 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/30 {
  --tw-gradient-from: rgb(239 246 255 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500 {
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/20 {
  --tw-gradient-from: rgb(59 130 246 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-900\\/40 {
  --tw-gradient-from: rgb(30 58 138 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-400 {
  --tw-gradient-from: #22d3ee var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 211 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500 {
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500\\/20 {
  --tw-gradient-from: rgb(6 182 212 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-600 {
  --tw-gradient-from: #059669 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 150 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-500\\/20 {
  --tw-gradient-from: rgb(107 114 128 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 114 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900 {
  --tw-gradient-from: #111827 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-100 {
  --tw-gradient-from: #dcfce7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 252 231 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500 {
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500\\/10 {
  --tw-gradient-from: rgb(34 197 94 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500\\/20 {
  --tw-gradient-from: rgb(34 197 94 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500 {
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-muted\\/50 {
  --tw-gradient-from: hsl(var(--muted) / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--muted) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500 {
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/10 {
  --tw-gradient-from: hsl(var(--primary) / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/20 {
  --tw-gradient-from: hsl(var(--primary) / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/40 {
  --tw-gradient-from: hsl(var(--primary) / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/80 {
  --tw-gradient-from: hsl(var(--primary) / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50\\/30 {
  --tw-gradient-from: rgb(250 245 255 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500 {
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500\\/20 {
  --tw-gradient-from: rgb(168 85 247 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-400 {
  --tw-gradient-from: #f87171 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 113 113 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500 {
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500\\/10 {
  --tw-gradient-from: rgb(239 68 68 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900 {
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-zinc-900 {
  --tw-gradient-from: #18181b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(24 24 27 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-background {
  --tw-gradient-to: hsl(var(--background) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--background)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/30 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-900 {
  --tw-gradient-to: rgb(88 28 135 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #581c87 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-secondary\\/20 {
  --tw-gradient-to: hsl(var(--secondary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--secondary) / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-accent\\/20 {
  --tw-gradient-to: hsl(var(--accent) / 0.2) var(--tw-gradient-to-position);
}
.to-background {
  --tw-gradient-to: hsl(var(--background)) var(--tw-gradient-to-position);
}
.to-blue-500 {
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-blue-500\\/20 {
  --tw-gradient-to: rgb(59 130 246 / 0.2) var(--tw-gradient-to-position);
}
.to-blue-600 {
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-cyan-500 {
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-cyan-500\\/20 {
  --tw-gradient-to: rgb(6 182 212 / 0.2) var(--tw-gradient-to-position);
}
.to-cyan-600 {
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-emerald-100 {
  --tw-gradient-to: #d1fae5 var(--tw-gradient-to-position);
}
.to-emerald-500\\/10 {
  --tw-gradient-to: rgb(16 185 129 / 0.1) var(--tw-gradient-to-position);
}
.to-emerald-500\\/20 {
  --tw-gradient-to: rgb(16 185 129 / 0.2) var(--tw-gradient-to-position);
}
.to-gray-600\\/20 {
  --tw-gradient-to: rgb(75 85 99 / 0.2) var(--tw-gradient-to-position);
}
.to-green-400 {
  --tw-gradient-to: #4ade80 var(--tw-gradient-to-position);
}
.to-indigo-600 {
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-muted {
  --tw-gradient-to: hsl(var(--muted)) var(--tw-gradient-to-position);
}
.to-orange-500 {
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-orange-500\\/10 {
  --tw-gradient-to: rgb(249 115 22 / 0.1) var(--tw-gradient-to-position);
}
.to-orange-500\\/20 {
  --tw-gradient-to: rgb(249 115 22 / 0.2) var(--tw-gradient-to-position);
}
.to-pink-50\\/30 {
  --tw-gradient-to: rgb(253 242 248 / 0.3) var(--tw-gradient-to-position);
}
.to-pink-500 {
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-pink-500\\/20 {
  --tw-gradient-to: rgb(236 72 153 / 0.2) var(--tw-gradient-to-position);
}
.to-pink-600 {
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}
.to-primary {
  --tw-gradient-to: hsl(var(--primary)) var(--tw-gradient-to-position);
}
.to-primary\\/10 {
  --tw-gradient-to: hsl(var(--primary) / 0.1) var(--tw-gradient-to-position);
}
.to-primary\\/40 {
  --tw-gradient-to: hsl(var(--primary) / 0.4) var(--tw-gradient-to-position);
}
.to-purple-100 {
  --tw-gradient-to: #f3e8ff var(--tw-gradient-to-position);
}
.to-purple-400 {
  --tw-gradient-to: #c084fc var(--tw-gradient-to-position);
}
.to-purple-50\\/30 {
  --tw-gradient-to: rgb(250 245 255 / 0.3) var(--tw-gradient-to-position);
}
.to-purple-500 {
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-purple-600 {
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-purple-900 {
  --tw-gradient-to: #581c87 var(--tw-gradient-to-position);
}
.to-purple-900\\/40 {
  --tw-gradient-to: rgb(88 28 135 / 0.4) var(--tw-gradient-to-position);
}
.to-red-500 {
  --tw-gradient-to: #ef4444 var(--tw-gradient-to-position);
}
.to-slate-900 {
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}
.to-teal-500 {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-violet-900 {
  --tw-gradient-to: #4c1d95 var(--tw-gradient-to-position);
}
.to-zinc-700 {
  --tw-gradient-to: #3f3f46 var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-blue-400\\/20 {
  fill: rgb(96 165 250 / 0.2);
}
.fill-current {
  fill: currentColor;
}
.fill-primary\\/20 {
  fill: hsl(var(--primary) / 0.2);
}
.fill-red-500 {
  fill: #ef4444;
}
.fill-white {
  fill: #fff;
}
.fill-yellow-500 {
  fill: #eab308;
}
.stroke-1 {
  stroke-width: 1;
}
.stroke-\\[0\\.1\\] {
  stroke-width: 0.1;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.object-center {
  -o-object-position: center;
     object-position: center;
}
.\\!p-0 {
  padding: 0px !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[1px\\] {
  padding: 1px;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-3\\.5 {
  padding-left: 0.875rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[15vh\\] {
  padding-top: 15vh;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-text-bottom {
  vertical-align: text-bottom;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-9xl {
  font-size: 8rem;
  line-height: 1;
}
.text-\\[0\\.625rem\\] {
  font-size: 0.625rem;
}
.text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.font-thin {
  font-weight: 100;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-loose {
  line-height: 2;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.3em\\] {
  letter-spacing: 0.3em;
}
.tracking-\\[0\\.4em\\] {
  letter-spacing: 0.4em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-accent {
  color: hsl(var(--accent));
}
.text-accent-foreground {
  color: hsl(var(--accent-foreground));
}
.text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-400\\/60 {
  color: rgb(251 191 36 / 0.6);
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-500\\/70 {
  color: rgb(245 158 11 / 0.7);
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-600\\/50 {
  color: rgb(217 119 6 / 0.5);
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-800\\/90 {
  color: rgb(146 64 14 / 0.9);
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-950 {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-300 {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-500\\/70 {
  color: rgb(59 130 246 / 0.7);
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-card-foreground {
  color: hsl(var(--card-foreground));
}
.text-current {
  color: currentColor;
}
.text-cyan-300 {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}
.text-cyan-400 {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-destructive {
  color: hsl(var(--destructive));
}
.text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}
.text-destructive\\/70 {
  color: hsl(var(--destructive) / 0.7);
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-500\\/70 {
  color: rgb(16 185 129 / 0.7);
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-foreground {
  color: hsl(var(--foreground));
}
.text-foreground\\/50 {
  color: hsl(var(--foreground) / 0.5);
}
.text-foreground\\/70 {
  color: hsl(var(--foreground) / 0.7);
}
.text-foreground\\/80 {
  color: hsl(var(--foreground) / 0.8);
}
.text-foreground\\/90 {
  color: hsl(var(--foreground) / 0.9);
}
.text-fuchsia-600 {
  --tw-text-opacity: 1;
  color: rgb(192 38 211 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-300 {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-600\\/70 {
  color: rgb(22 163 74 / 0.7);
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-500\\/70 {
  color: rgb(99 102 241 / 0.7);
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-inherit {
  color: inherit;
}
.text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.text-muted-foreground\\/20 {
  color: hsl(var(--muted-foreground) / 0.2);
}
.text-muted-foreground\\/40 {
  color: hsl(var(--muted-foreground) / 0.4);
}
.text-muted-foreground\\/50 {
  color: hsl(var(--muted-foreground) / 0.5);
}
.text-muted-foreground\\/60 {
  color: hsl(var(--muted-foreground) / 0.6);
}
.text-muted-foreground\\/70 {
  color: hsl(var(--muted-foreground) / 0.7);
}
.text-muted-foreground\\/90 {
  color: hsl(var(--muted-foreground) / 0.9);
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-500\\/70 {
  color: rgb(249 115 22 / 0.7);
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity, 1));
}
.text-pink-500\\/70 {
  color: rgb(236 72 153 / 0.7);
}
.text-pink-600 {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-popover-foreground {
  color: hsl(var(--popover-foreground));
}
.text-primary {
  color: hsl(var(--primary));
}
.text-primary-foreground {
  color: hsl(var(--primary-foreground));
}
.text-primary-foreground\\/60 {
  color: hsl(var(--primary-foreground) / 0.6);
}
.text-primary\\/20 {
  color: hsl(var(--primary) / 0.2);
}
.text-primary\\/30 {
  color: hsl(var(--primary) / 0.3);
}
.text-primary\\/40 {
  color: hsl(var(--primary) / 0.4);
}
.text-primary\\/70 {
  color: hsl(var(--primary) / 0.7);
}
.text-primary\\/80 {
  color: hsl(var(--primary) / 0.8);
}
.text-purple-300 {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.text-purple-400 {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700 {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-secondary {
  color: hsl(var(--secondary));
}
.text-secondary-foreground {
  color: hsl(var(--secondary-foreground));
}
.text-sidebar-foreground {
  color: hsl(var(--sidebar-foreground));
}
.text-sidebar-foreground\\/70 {
  color: hsl(var(--sidebar-foreground) / 0.7);
}
.text-sky-500 {
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.text-sky-500\\/70 {
  color: rgb(14 165 233 / 0.7);
}
.text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-700 {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-sky-800 {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-sky-900 {
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity, 1));
}
.text-sky-900\\/40 {
  color: rgb(12 74 110 / 0.4);
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-teal-300 {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1));
}
.text-teal-400 {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity, 1));
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-tiktok-red {
  --tw-text-opacity: 1;
  color: rgb(238 29 82 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-violet-400 {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-violet-500\\/70 {
  color: rgb(139 92 246 / 0.7);
}
.text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-800 {
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/50 {
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/60 {
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-600\\/70 {
  color: rgb(202 138 4 / 0.7);
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-700\\/70 {
  color: rgb(161 98 7 / 0.7);
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}
.text-zinc-100 {
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity, 1));
}
.text-zinc-900 {
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.no-underline {
  text-decoration-line: none;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.placeholder-slate-500::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(100 116 139 / var(--tw-placeholder-opacity, 1));
}
.placeholder-slate-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(100 116 139 / var(--tw-placeholder-opacity, 1));
}
.placeholder-white\\/40::-moz-placeholder {
  color: rgb(255 255 255 / 0.4);
}
.placeholder-white\\/40::placeholder {
  color: rgb(255 255 255 / 0.4);
}
.placeholder-white\\/60::-moz-placeholder {
  color: rgb(255 255 255 / 0.6);
}
.placeholder-white\\/60::placeholder {
  color: rgb(255 255 255 / 0.6);
}
.accent-primary {
  accent-color: hsl(var(--primary));
}
.accent-purple-500 {
  accent-color: #a855f7;
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.mix-blend-normal {
  mix-blend-mode: normal;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-border\\)\\)\\] {
  --tw-shadow: 0 0 0 1px hsl(var(--sidebar-border));
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_9999px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 0 0 9999px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 0 0 9999px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_15px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.4\\)\\] {
  --tw-shadow: 0 0 15px rgba(59,130,246,0.4);
  --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(34\\2c 197\\2c 94\\2c 0\\.6\\)\\] {
  --tw-shadow: 0 0 8px rgba(34,197,94,0.6);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_12px_-4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 4px 12px -4px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 4px 12px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_-10px_0_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.02\\)\\] {
  --tw-shadow: inset -10px 0 20px rgba(0,0,0,0.02);
  --tw-shadow-colored: inset -10px 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\] {
  --tw-shadow: inset 0 0 40px rgba(0,0,0,0.05);
  --tw-shadow-colored: inset 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
  --tw-shadow: inset 0 0 60px rgba(0,0,0,0.1);
  --tw-shadow-colored: inset 0 0 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_15px_0_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.03\\)\\] {
  --tw-shadow: inset 15px 0 30px rgba(0,0,0,0.03);
  --tw-shadow-colored: inset 15px 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-black\\/5 {
  --tw-shadow-color: rgb(0 0 0 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-400\\/50 {
  --tw-shadow-color: rgb(74 222 128 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/50 {
  --tw-shadow-color: rgb(34 197 94 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary\\/20 {
  --tw-shadow-color: hsl(var(--primary) / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary\\/30 {
  --tw-shadow-color: hsl(var(--primary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-black\\/10 {
  --tw-ring-color: rgb(0 0 0 / 0.1);
}
.ring-blue-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.ring-blue-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.ring-blue-500\\/10 {
  --tw-ring-color: rgb(59 130 246 / 0.1);
}
.ring-destructive {
  --tw-ring-color: hsl(var(--destructive));
}
.ring-gray-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}
.ring-green-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 222 128 / var(--tw-ring-opacity, 1));
}
.ring-green-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}
.ring-primary {
  --tw-ring-color: hsl(var(--primary));
}
.ring-primary\\/20 {
  --tw-ring-color: hsl(var(--primary) / 0.2);
}
.ring-primary\\/30 {
  --tw-ring-color: hsl(var(--primary) / 0.3);
}
.ring-primary\\/50 {
  --tw-ring-color: hsl(var(--primary) / 0.5);
}
.ring-purple-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(192 132 252 / var(--tw-ring-opacity, 1));
}
.ring-purple-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}
.ring-ring {
  --tw-ring-color: hsl(var(--ring));
}
.ring-sidebar-ring {
  --tw-ring-color: hsl(var(--sidebar-ring));
}
.ring-sky-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(56 189 248 / var(--tw-ring-opacity, 1));
}
.ring-slate-900\\/5 {
  --tw-ring-color: rgb(15 23 42 / 0.05);
}
.ring-white\\/25 {
  --tw-ring-color: rgb(255 255 255 / 0.25);
}
.ring-opacity-50 {
  --tw-ring-opacity: 0.5;
}
.ring-offset-1 {
  --tw-ring-offset-width: 1px;
}
.ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm {
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg {
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm {
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale-0 {
  --tw-grayscale: grayscale(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale-\\[0\\.2\\] {
  --tw-grayscale: grayscale(0.2);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale-\\[0\\.3\\] {
  --tw-grayscale: grayscale(0.3);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale-\\[0\\.5\\] {
  --tw-grayscale: grayscale(0.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert-0 {
  --tw-invert: invert(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sepia {
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[1px\\] {
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\] {
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-none {
  --tw-backdrop-blur:  ;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[left\\2c right\\2c width\\] {
  transition-property: left,right,width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[margin\\2c opa\\] {
  transition-property: margin,opa;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\2c height\\2c padding\\] {
  transition-property: width,height,padding;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-100 {
  transition-delay: 100ms;
}
.delay-200 {
  transition-delay: 200ms;
}
.delay-300 {
  transition-delay: 300ms;
}
.delay-500 {
  transition-delay: 500ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  transition-timing-function: linear;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.animate-out {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.fade-in {
  --tw-enter-opacity: 0;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.fade-in-80 {
  --tw-enter-opacity: 0.8;
}
.fade-out {
  --tw-exit-opacity: 0;
}
.zoom-in {
  --tw-enter-scale: 0;
}
.zoom-in-50 {
  --tw-enter-scale: .5;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.zoom-out {
  --tw-exit-scale: 0;
}
.slide-in-from-bottom-2 {
  --tw-enter-translate-y: 0.5rem;
}
.slide-in-from-left-2 {
  --tw-enter-translate-x: -0.5rem;
}
.slide-in-from-right-2 {
  --tw-enter-translate-x: 0.5rem;
}
.slide-in-from-top-1 {
  --tw-enter-translate-y: -0.25rem;
}
.slide-in-from-top-2 {
  --tw-enter-translate-y: -0.5rem;
}
.duration-100 {
  animation-duration: 100ms;
}
.duration-1000 {
  animation-duration: 1000ms;
}
.duration-150 {
  animation-duration: 150ms;
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.duration-500 {
  animation-duration: 500ms;
}
.duration-700 {
  animation-duration: 700ms;
}
.duration-75 {
  animation-duration: 75ms;
}
.delay-100 {
  animation-delay: 100ms;
}
.delay-200 {
  animation-delay: 200ms;
}
.delay-300 {
  animation-delay: 300ms;
}
.delay-500 {
  animation-delay: 500ms;
}
.ease-in {
  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  animation-timing-function: linear;
}
.ease-out {
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.running {
  animation-play-state: running;
}
.paused {
  animation-play-state: paused;
}
.scrollbar-hide {
    -ms-overflow-style: none;
    /* Internet Explorer 10+ */
    scrollbar-width: none;
    /* Firefox */
  }
.scrollbar-hide::-webkit-scrollbar {
    display: none;
    /* Safari and Chrome */
  }
/* Custom thin scrollbar */
.scrollbar-custom::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
.scrollbar-custom::-webkit-scrollbar-track {
    background: transparent;
  }
.scrollbar-custom::-webkit-scrollbar-thumb {
    background-color: hsl(var(--muted-foreground) / 0.3);
    border-radius: 20px;
  }
.scrollbar-custom::-webkit-scrollbar-thumb:hover {
    background-color: hsl(var(--muted-foreground) / 0.5);
  }
/* Force background transparency in dark mode to show global pattern */
.dark .bg-background {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }
.\\[grid-template-columns\\:minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: minmax(0,1fr);
}

/* Photo sharing app design system - modern gradients and glass effects */

/* TikTok-style Video Player Overrides */

.dark\\:prose-invert:is(.dark *) {
  --tw-prose-body: var(--tw-prose-invert-body);
  --tw-prose-headings: var(--tw-prose-invert-headings);
  --tw-prose-lead: var(--tw-prose-invert-lead);
  --tw-prose-links: var(--tw-prose-invert-links);
  --tw-prose-bold: var(--tw-prose-invert-bold);
  --tw-prose-counters: var(--tw-prose-invert-counters);
  --tw-prose-bullets: var(--tw-prose-invert-bullets);
  --tw-prose-hr: var(--tw-prose-invert-hr);
  --tw-prose-quotes: var(--tw-prose-invert-quotes);
  --tw-prose-quote-borders: var(--tw-prose-invert-quote-borders);
  --tw-prose-captions: var(--tw-prose-invert-captions);
  --tw-prose-kbd: var(--tw-prose-invert-kbd);
  --tw-prose-kbd-shadows: var(--tw-prose-invert-kbd-shadows);
  --tw-prose-code: var(--tw-prose-invert-code);
  --tw-prose-pre-code: var(--tw-prose-invert-pre-code);
  --tw-prose-pre-bg: var(--tw-prose-invert-pre-bg);
  --tw-prose-th-borders: var(--tw-prose-invert-th-borders);
  --tw-prose-td-borders: var(--tw-prose-invert-td-borders);
}

.file\\:border-0::file-selector-button {
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}

.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:text-xs::file-selector-button {
  font-size: 0.75rem;
  line-height: 1rem;
}

.file\\:font-medium::file-selector-button {
  font-weight: 500;
}

.file\\:text-foreground::file-selector-button {
  color: hsl(var(--foreground));
}

.placeholder\\:text-muted-foreground::-moz-placeholder {
  color: hsl(var(--muted-foreground));
}

.placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:inset-0::before {
  content: var(--tw-content);
  inset: 0px;
}

.before\\:-z-10::before {
  content: var(--tw-content);
  z-index: -10;
}

.before\\:rounded-sm::before {
  content: var(--tw-content);
  border-radius: calc(var(--radius) - 4px);
}

.before\\:bg-muted\\/50::before {
  content: var(--tw-content);
  background-color: hsl(var(--muted) / 0.5);
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:-inset-2::after {
  content: var(--tw-content);
  inset: -0.5rem;
}

.after\\:inset-y-0::after {
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}

.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}

.after\\:w-1::after {
  content: var(--tw-content);
  width: 0.25rem;
}

.after\\:w-\\[2px\\]::after {
  content: var(--tw-content);
  width: 2px;
}

.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.first\\:rounded-l-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.first\\:border-l:first-child {
  border-left-width: 1px;
}

.last\\:rounded-r-md:last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.last\\:border-0:last-child {
  border-width: 0px;
}

.last\\:border-r-0:last-child {
  border-right-width: 0px;
}

.last\\:pb-0:last-child {
  padding-bottom: 0px;
}

.empty\\:hidden:empty {
  display: none;
}

.focus-within\\:relative:focus-within {
  position: relative;
}

.focus-within\\:z-20:focus-within {
  z-index: 20;
}

.focus-within\\:border-indigo-500:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.01\\]:hover {
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-accent:hover {
  border-color: hsl(var(--accent));
}

.hover\\:border-amber-400\\/60:hover {
  border-color: rgb(251 191 36 / 0.6);
}

.hover\\:border-blue-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-400\\/60:hover {
  border-color: rgb(96 165 250 / 0.6);
}

.hover\\:border-border:hover {
  border-color: hsl(var(--border));
}

.hover\\:border-border\\/80:hover {
  border-color: hsl(var(--border) / 0.8);
}

.hover\\:border-cyan-400\\/60:hover {
  border-color: rgb(34 211 238 / 0.6);
}

.hover\\:border-destructive\\/30:hover {
  border-color: hsl(var(--destructive) / 0.3);
}

.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-400\\/60:hover {
  border-color: rgb(156 163 175 / 0.6);
}

.hover\\:border-green-400\\/60:hover {
  border-color: rgb(74 222 128 / 0.6);
}

.hover\\:border-indigo-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.hover\\:border-muted-foreground\\/30:hover {
  border-color: hsl(var(--muted-foreground) / 0.3);
}

.hover\\:border-primary:hover {
  border-color: hsl(var(--primary));
}

.hover\\:border-primary\\/30:hover {
  border-color: hsl(var(--primary) / 0.3);
}

.hover\\:border-primary\\/50:hover {
  border-color: hsl(var(--primary) / 0.5);
}

.hover\\:border-purple-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-400\\/60:hover {
  border-color: rgb(192 132 252 / 0.6);
}

.hover\\:border-purple-500\\/30:hover {
  border-color: rgb(168 85 247 / 0.3);
}

.hover\\:border-slate-400\\/60:hover {
  border-color: rgb(148 163 184 / 0.6);
}

.hover\\:border-white\\/10:hover {
  border-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-accent:hover {
  background-color: hsl(var(--accent));
}

.hover\\:bg-accent\\/40:hover {
  background-color: hsl(var(--accent) / 0.4);
}

.hover\\:bg-accent\\/5:hover {
  background-color: hsl(var(--accent) / 0.05);
}

.hover\\:bg-accent\\/50:hover {
  background-color: hsl(var(--accent) / 0.5);
}

.hover\\:bg-accent\\/60:hover {
  background-color: hsl(var(--accent) / 0.6);
}

.hover\\:bg-amber-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-200\\/60:hover {
  background-color: rgb(253 230 138 / 0.6);
}

.hover\\:bg-amber-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-50\\/50:hover {
  background-color: rgb(255 251 235 / 0.5);
}

.hover\\:bg-background:hover {
  background-color: hsl(var(--background));
}

.hover\\:bg-background\\/40:hover {
  background-color: hsl(var(--background) / 0.4);
}

.hover\\:bg-background\\/60:hover {
  background-color: hsl(var(--background) / 0.6);
}

.hover\\:bg-background\\/80:hover {
  background-color: hsl(var(--background) / 0.8);
}

.hover\\:bg-background\\/90:hover {
  background-color: hsl(var(--background) / 0.9);
}

.hover\\:bg-black\\/40:hover {
  background-color: rgb(0 0 0 / 0.4);
}

.hover\\:bg-black\\/5:hover {
  background-color: rgb(0 0 0 / 0.05);
}

.hover\\:bg-black\\/50:hover {
  background-color: rgb(0 0 0 / 0.5);
}

.hover\\:bg-black\\/60:hover {
  background-color: rgb(0 0 0 / 0.6);
}

.hover\\:bg-black\\/70:hover {
  background-color: rgb(0 0 0 / 0.7);
}

.hover\\:bg-black\\/90:hover {
  background-color: rgb(0 0 0 / 0.9);
}

.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-100\\/20:hover {
  background-color: rgb(219 234 254 / 0.2);
}

.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50\\/30:hover {
  background-color: rgb(239 246 255 / 0.3);
}

.hover\\:bg-blue-500\\/30:hover {
  background-color: rgb(59 130 246 / 0.3);
}

.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-500\\/20:hover {
  background-color: rgb(6 182 212 / 0.2);
}

.hover\\:bg-cyan-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-destructive:hover {
  background-color: hsl(var(--destructive));
}

.hover\\:bg-destructive\\/10:hover {
  background-color: hsl(var(--destructive) / 0.1);
}

.hover\\:bg-destructive\\/20:hover {
  background-color: hsl(var(--destructive) / 0.2);
}

.hover\\:bg-destructive\\/80:hover {
  background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-emerald-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-500\\/20:hover {
  background-color: rgb(34 197 94 / 0.2);
}

.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-500\\/50:hover {
  background-color: rgb(99 102 241 / 0.5);
}

.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-muted:hover {
  background-color: hsl(var(--muted));
}

.hover\\:bg-muted-foreground\\/10:hover {
  background-color: hsl(var(--muted-foreground) / 0.1);
}

.hover\\:bg-muted\\/20:hover {
  background-color: hsl(var(--muted) / 0.2);
}

.hover\\:bg-muted\\/30:hover {
  background-color: hsl(var(--muted) / 0.3);
}

.hover\\:bg-muted\\/40:hover {
  background-color: hsl(var(--muted) / 0.4);
}

.hover\\:bg-muted\\/50:hover {
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-muted\\/60:hover {
  background-color: hsl(var(--muted) / 0.6);
}

.hover\\:bg-muted\\/70:hover {
  background-color: hsl(var(--muted) / 0.7);
}

.hover\\:bg-muted\\/80:hover {
  background-color: hsl(var(--muted) / 0.8);
}

.hover\\:bg-orange-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-pink-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary:hover {
  background-color: hsl(var(--primary));
}

.hover\\:bg-primary-foreground\\/10:hover {
  background-color: hsl(var(--primary-foreground) / 0.1);
}

.hover\\:bg-primary\\/10:hover {
  background-color: hsl(var(--primary) / 0.1);
}

.hover\\:bg-primary\\/20:hover {
  background-color: hsl(var(--primary) / 0.2);
}

.hover\\:bg-primary\\/40:hover {
  background-color: hsl(var(--primary) / 0.4);
}

.hover\\:bg-primary\\/5:hover {
  background-color: hsl(var(--primary) / 0.05);
}

.hover\\:bg-primary\\/80:hover {
  background-color: hsl(var(--primary) / 0.8);
}

.hover\\:bg-primary\\/90:hover {
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-purple-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-500\\/20:hover {
  background-color: rgb(168 85 247 / 0.2);
}

.hover\\:bg-purple-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-500\\/10:hover {
  background-color: rgb(239 68 68 / 0.1);
}

.hover\\:bg-red-500\\/20:hover {
  background-color: rgb(239 68 68 / 0.2);
}

.hover\\:bg-red-500\\/30:hover {
  background-color: rgb(239 68 68 / 0.3);
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-50\\/50:hover {
  background-color: rgb(255 241 242 / 0.5);
}

.hover\\:bg-secondary:hover {
  background-color: hsl(var(--secondary));
}

.hover\\:bg-secondary\\/80:hover {
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:bg-secondary\\/90:hover {
  background-color: hsl(var(--secondary) / 0.9);
}

.hover\\:bg-sidebar-accent:hover {
  background-color: hsl(var(--sidebar-accent));
}

.hover\\:bg-sky-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-sky-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-sky-50\\/50:hover {
  background-color: rgb(240 249 255 / 0.5);
}

.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-200\\/50:hover {
  background-color: rgb(226 232 240 / 0.5);
}

.hover\\:bg-teal-600\\/30:hover {
  background-color: rgb(13 148 136 / 0.3);
}

.hover\\:bg-teal-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-transparent:hover {
  background-color: transparent;
}

.hover\\:bg-violet-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-white\\/25:hover {
  background-color: rgb(255 255 255 / 0.25);
}

.hover\\:bg-white\\/30:hover {
  background-color: rgb(255 255 255 / 0.3);
}

.hover\\:bg-white\\/5:hover {
  background-color: rgb(255 255 255 / 0.05);
}

.hover\\:bg-white\\/50:hover {
  background-color: rgb(255 255 255 / 0.5);
}

.hover\\:bg-white\\/80:hover {
  background-color: rgb(255 255 255 / 0.8);
}

.hover\\:bg-yellow-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-yellow-200\\/50:hover {
  background-color: rgb(254 240 138 / 0.5);
}

.hover\\:bg-yellow-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity, 1));
}

.hover\\:from-amber-500\\/30:hover {
  --tw-gradient-from: rgb(245 158 11 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blue-200:hover {
  --tw-gradient-from: #bfdbfe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(191 219 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blue-500\\/30:hover {
  --tw-gradient-from: rgb(59 130 246 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blue-600:hover {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-cyan-500\\/30:hover {
  --tw-gradient-from: rgb(6 182 212 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-cyan-600:hover {
  --tw-gradient-from: #0891b2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(8 145 178 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-gray-500\\/30:hover {
  --tw-gradient-from: rgb(107 114 128 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 114 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-green-500\\/30:hover {
  --tw-gradient-from: rgb(34 197 94 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-indigo-600:hover {
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-500:hover {
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-500\\/30:hover {
  --tw-gradient-from: rgb(168 85 247 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-600:hover {
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-700:hover {
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-red-600:hover {
  --tw-gradient-from: #dc2626 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 38 38 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-blue-500\\/30:hover {
  --tw-gradient-to: rgb(59 130 246 / 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blue-700:hover {
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}

.hover\\:to-cyan-500:hover {
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}

.hover\\:to-cyan-500\\/30:hover {
  --tw-gradient-to: rgb(6 182 212 / 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-emerald-500\\/30:hover {
  --tw-gradient-to: rgb(16 185 129 / 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-gray-600\\/30:hover {
  --tw-gradient-to: rgb(75 85 99 / 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-orange-500\\/30:hover {
  --tw-gradient-to: rgb(249 115 22 / 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-pink-500\\/30:hover {
  --tw-gradient-to: rgb(236 72 153 / 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-pink-600:hover {
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}

.hover\\:to-purple-200:hover {
  --tw-gradient-to: #e9d5ff var(--tw-gradient-to-position);
}

.hover\\:to-purple-600:hover {
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}

.hover\\:to-purple-700:hover {
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}

.hover\\:text-accent-foreground:hover {
  color: hsl(var(--accent-foreground));
}

.hover\\:text-amber-200:hover {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}

.hover\\:text-amber-600:hover {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}

.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-200:hover {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-400:hover {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-900:hover {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}

.hover\\:text-cyan-200:hover {
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity, 1));
}

.hover\\:text-cyan-400:hover {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}

.hover\\:text-destructive:hover {
  color: hsl(var(--destructive));
}

.hover\\:text-destructive\\/80:hover {
  color: hsl(var(--destructive) / 0.8);
}

.hover\\:text-emerald-600:hover {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-700:hover {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}

.hover\\:text-foreground:hover {
  color: hsl(var(--foreground));
}

.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-300:hover {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-400:hover {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-200:hover {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-400:hover {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-500:hover {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-700:hover {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-500:hover {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-600:hover {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-700:hover {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}

.hover\\:text-muted-foreground:hover {
  color: hsl(var(--muted-foreground));
}

.hover\\:text-orange-600:hover {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}

.hover\\:text-pink-500:hover {
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity, 1));
}

.hover\\:text-pink-600:hover {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}

.hover\\:text-pink-800:hover {
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary:hover {
  color: hsl(var(--primary));
}

.hover\\:text-primary-foreground:hover {
  color: hsl(var(--primary-foreground));
}

.hover\\:text-primary\\/80:hover {
  color: hsl(var(--primary) / 0.8);
}

.hover\\:text-purple-200:hover {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-300:hover {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-400:hover {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-300:hover {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-800:hover {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.hover\\:text-sidebar-accent-foreground:hover {
  color: hsl(var(--sidebar-accent-foreground));
}

.hover\\:text-sky-600:hover {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-700:hover {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-900:hover {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.hover\\:text-tiktok-red:hover {
  --tw-text-opacity: 1;
  color: rgb(238 29 82 / var(--tw-text-opacity, 1));
}

.hover\\:text-violet-600:hover {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-white\\/80:hover {
  color: rgb(255 255 255 / 0.8);
}

.hover\\:text-yellow-400:hover {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}

.hover\\:text-yellow-900:hover {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:no-underline:hover {
  text-decoration-line: none;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-70:hover {
  opacity: 0.7;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:opacity-90:hover {
  opacity: 0.9;
}

.hover\\:opacity-95:hover {
  opacity: 0.95;
}

.hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-accent\\)\\)\\]:hover {
  --tw-shadow: 0 0 0 1px hsl(var(--sidebar-accent));
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-glow:hover {
  --tw-shadow: var(--glow-shadow);
  --tw-shadow-colored: var(--glow-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-amber-500\\/20:hover {
  --tw-shadow-color: rgb(245 158 11 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-500\\/20:hover {
  --tw-shadow-color: rgb(59 130 246 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-cyan-500\\/20:hover {
  --tw-shadow-color: rgb(6 182 212 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-gray-500\\/20:hover {
  --tw-shadow-color: rgb(107 114 128 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-green-500\\/20:hover {
  --tw-shadow-color: rgb(34 197 94 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-purple-500\\/20:hover {
  --tw-shadow-color: rgb(168 85 247 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:ring-1:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.hover\\:ring-2:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.hover\\:ring-primary:hover {
  --tw-ring-color: hsl(var(--primary));
}

.hover\\:ring-purple-300:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(216 180 254 / var(--tw-ring-opacity, 1));
}

.hover\\:grayscale-0:hover {
  --tw-grayscale: grayscale(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.dark .hover\\:bg-background:hover {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }

.hover\\:after\\:bg-sidebar-border:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--sidebar-border));
}

.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.focus\\:border-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:border-white\\/60:focus {
  border-color: rgb(255 255 255 / 0.6);
}

.focus\\:bg-accent:focus {
  background-color: hsl(var(--accent));
}

.focus\\:bg-background:focus {
  background-color: hsl(var(--background));
}

.focus\\:bg-primary:focus {
  background-color: hsl(var(--primary));
}

.focus\\:bg-red-50:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-red-500\\/10:focus {
  background-color: rgb(239 68 68 / 0.1);
}

.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:text-accent-foreground:focus {
  color: hsl(var(--accent-foreground));
}

.focus\\:text-amber-700:focus {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}

.focus\\:text-blue-500:focus {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}

.focus\\:text-blue-700:focus {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.focus\\:text-destructive:focus {
  color: hsl(var(--destructive));
}

.focus\\:text-emerald-700:focus {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}

.focus\\:text-green-700:focus {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.focus\\:text-orange-700:focus {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}

.focus\\:text-pink-700:focus {
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}

.focus\\:text-primary-foreground:focus {
  color: hsl(var(--primary-foreground));
}

.focus\\:text-red-500:focus {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.focus\\:text-red-600:focus {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.focus\\:text-sky-700:focus {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}

.focus\\:text-violet-700:focus {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}

.focus\\:underline:focus {
  text-decoration-line: underline;
}

.focus\\:opacity-100:focus {
  opacity: 1;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-inset:focus {
  --tw-ring-inset: inset;
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary:focus {
  --tw-ring-color: hsl(var(--primary));
}

.focus\\:ring-primary\\/20:focus {
  --tw-ring-color: hsl(var(--primary) / 0.2);
}

.focus\\:ring-purple-500\\/20:focus {
  --tw-ring-color: rgb(168 85 247 / 0.2);
}

.focus\\:ring-purple-500\\/50:focus {
  --tw-ring-color: rgb(168 85 247 / 0.5);
}

.focus\\:ring-ring:focus {
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-white:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.dark .focus\\:bg-background:focus {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }

.focus-visible\\:border-primary:focus-visible {
  border-color: hsl(var(--primary));
}

.focus-visible\\:opacity-100:focus-visible {
  opacity: 1;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-0:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-primary:focus-visible {
  --tw-ring-color: hsl(var(--primary));
}

.focus-visible\\:ring-primary\\/20:focus-visible {
  --tw-ring-color: hsl(var(--primary) / 0.2);
}

.focus-visible\\:ring-primary\\/50:focus-visible {
  --tw-ring-color: hsl(var(--primary) / 0.5);
}

.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-sidebar-ring:focus-visible {
  --tw-ring-color: hsl(var(--sidebar-ring));
}

.focus-visible\\:ring-offset-0:focus-visible {
  --tw-ring-offset-width: 0px;
}

.focus-visible\\:ring-offset-1:focus-visible {
  --tw-ring-offset-width: 1px;
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: hsl(var(--background));
}

.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.99\\]:active {
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active {
  cursor: grabbing;
}

.active\\:bg-indigo-500:active {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}

.active\\:bg-sidebar-accent:active {
  background-color: hsl(var(--sidebar-accent));
}

.active\\:text-sidebar-accent-foreground:active {
  color: hsl(var(--sidebar-accent-foreground));
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-0:disabled {
  opacity: 0;
}

.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group:focus-within .group-focus-within\\:text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}

.group\\/menu-item:focus-within .group-focus-within\\/menu-item\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:visible {
  visibility: visible;
}

.group:hover .group-hover\\:rotate-12 {
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes pulse {

  50% {
    opacity: .5;
  }
}

.group:hover .group-hover\\:animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.group:hover .group-hover\\:border-primary {
  border-color: hsl(var(--primary));
}

.group:hover .group-hover\\:border-primary\\/50 {
  border-color: hsl(var(--primary) / 0.5);
}

.group:hover .group-hover\\:bg-background {
  background-color: hsl(var(--background));
}

.group:hover .group-hover\\:bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}

.group:hover .group-hover\\:bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}

.group:hover .group-hover\\:bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}

.group:hover .group-hover\\:bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-primary\\/10 {
  background-color: hsl(var(--primary) / 0.1);
}

.group:hover .group-hover\\:bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.group\\/row:hover .group-hover\\/row\\:text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-foreground {
  color: hsl(var(--foreground));
}

.group:hover .group-hover\\:text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-muted-foreground {
  color: hsl(var(--muted-foreground));
}

.group:hover .group-hover\\:text-primary {
  color: hsl(var(--primary));
}

.group:hover .group-hover\\:text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}

.group\\/row:hover .group-hover\\/row\\:underline {
  text-decoration-line: underline;
}

.group:hover .group-hover\\:underline {
  text-decoration-line: underline;
}

.group\\/btn:hover .group-hover\\/btn\\:opacity-100 {
  opacity: 1;
}

.group\\/member:hover .group-hover\\/member\\:opacity-100 {
  opacity: 1;
}

.group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:opacity-50 {
  opacity: 0.5;
}

.group:hover .group-hover\\:opacity-60 {
  opacity: 0.6;
}

.group:hover .group-hover\\:opacity-80 {
  opacity: 0.8;
}

.group:hover .group-hover\\:grayscale-0 {
  --tw-grayscale: grayscale(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.dark .group:hover .group-hover\\:bg-background {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40 {
  border-color: hsl(var(--muted) / 0.4);
}

.group.toaster .group-\\[\\.toaster\\]\\:border-border {
  border-color: hsl(var(--border));
}

.group.toast .group-\\[\\.toast\\]\\:bg-muted {
  background-color: hsl(var(--muted));
}

.group.toast .group-\\[\\.toast\\]\\:bg-primary {
  background-color: hsl(var(--primary));
}

.group.toaster .group-\\[\\.toaster\\]\\:bg-background {
  background-color: hsl(var(--background));
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground {
  color: hsl(var(--muted-foreground));
}

.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground {
  color: hsl(var(--primary-foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:text-foreground {
  color: hsl(var(--foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark .group.toaster .group-\\[\\.toaster\\]\\:bg-background {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover {
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover {
  background-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover {
  color: hsl(var(--destructive-foreground));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus {
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus {
  --tw-ring-offset-color: #dc2626;
}

.peer\\/menu-button:hover ~ .peer-hover\\/menu-button\\:text-sidebar-accent-foreground {
  color: hsl(var(--sidebar-accent-foreground));
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}

.has-\\[\\[data-variant\\=inset\\]\\]\\:bg-sidebar:has([data-variant=inset]) {
  background-color: hsl(var(--sidebar-background));
}

.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled) {
  opacity: 0.5;
}

.group\\/menu-item:has([data-sidebar=menu-action]) .group-has-\\[\\[data-sidebar\\=menu-action\\]\\]\\/menu-item\\:pr-8 {
  padding-right: 2rem;
}

.aria-disabled\\:pointer-events-none[aria-disabled="true"] {
  pointer-events: none;
}

.aria-disabled\\:opacity-50[aria-disabled="true"] {
  opacity: 0.5;
}

.aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(var(--accent));
}

.aria-selected\\:bg-accent\\/50[aria-selected="true"] {
  background-color: hsl(var(--accent) / 0.5);
}

.aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(var(--accent-foreground));
}

.aria-selected\\:text-muted-foreground[aria-selected="true"] {
  color: hsl(var(--muted-foreground));
}

.aria-selected\\:opacity-100[aria-selected="true"] {
  opacity: 1;
}

.aria-selected\\:opacity-30[aria-selected="true"] {
  opacity: 0.3;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
  pointer-events: none;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}

.data-\\[state\\=inactive\\]\\:hidden[data-state="inactive"] {
  display: none;
}

.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"] {
  height: 1px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"] {
  width: 100%;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"] {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"] {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"] {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"] {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-5[data-state="checked"] {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"] {
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"] {
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes accordion-up {

  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"] {
  animation: accordion-up 0.2s ease-out;
}

@keyframes accordion-down {

  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"] {
  animation: accordion-down 0.2s ease-out;
}

.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"] {
  flex-direction: column;
}

.data-\\[state\\=active\\]\\:border-primary[data-state="active"] {
  border-color: hsl(var(--primary));
}

.data-\\[active\\=true\\]\\:bg-sidebar-accent[data-active="true"] {
  background-color: hsl(var(--sidebar-accent));
}

.data-\\[active\\]\\:bg-accent\\/50[data-active] {
  background-color: hsl(var(--accent) / 0.5);
}

.data-\\[selected\\=\\'true\\'\\]\\:bg-accent[data-selected='true'] {
  background-color: hsl(var(--accent));
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
  background-color: hsl(var(--background));
}

.data-\\[state\\=active\\]\\:bg-muted[data-state="active"] {
  background-color: hsl(var(--muted));
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
  background-color: hsl(var(--primary));
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"] {
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"] {
  background-color: hsl(var(--accent) / 0.5);
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"] {
  background-color: hsl(var(--secondary));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"] {
  background-color: hsl(var(--muted));
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"] {
  background-color: hsl(var(--input));
}

.data-\\[active\\=true\\]\\:font-medium[data-active="true"] {
  font-weight: 500;
}

.data-\\[active\\=true\\]\\:text-sidebar-accent-foreground[data-active="true"] {
  color: hsl(var(--sidebar-accent-foreground));
}

.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"] {
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"] {
  color: hsl(var(--foreground));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
  color: hsl(var(--primary-foreground));
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"] {
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"] {
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"] {
  color: hsl(var(--muted-foreground));
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"] {
  opacity: 0.5;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}

.data-\\[state\\=open\\]\\:opacity-100[data-state="open"] {
  opacity: 1;
}

.data-\\[state\\=active\\]\\:shadow-none[data-state="active"] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"] {
  transition-property: none;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  transition-duration: 500ms;
}

.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"] {
  --tw-enter-opacity: 0;
}

.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"] {
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"] {
  --tw-exit-opacity: 0.8;
}

.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"] {
  --tw-exit-opacity: 0;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
  --tw-enter-opacity: 0;
}

.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"] {
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"] {
  --tw-enter-scale: .9;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
  --tw-enter-scale: .95;
}

.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"] {
  --tw-enter-translate-x: 13rem;
}

.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"] {
  --tw-enter-translate-x: -13rem;
}

.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"] {
  --tw-exit-translate-x: 13rem;
}

.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"] {
  --tw-exit-translate-x: -13rem;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"] {
  --tw-exit-translate-y: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
  --tw-exit-translate-x: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"] {
  --tw-exit-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"] {
  --tw-enter-translate-y: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
  --tw-enter-translate-x: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
  --tw-enter-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"] {
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"] {
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  animation-duration: 500ms;
}

.dark .data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  left: 0px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  height: 0.25rem;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  width: 100%;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=open\\]\\:hover\\:bg-sidebar-accent:hover[data-state="open"] {
  background-color: hsl(var(--sidebar-accent));
}

.data-\\[state\\=open\\]\\:hover\\:text-sidebar-accent-foreground:hover[data-state="open"] {
  color: hsl(var(--sidebar-accent-foreground));
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:left-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\] {
  left: calc(var(--sidebar-width) * -1);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:right-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\] {
  right: calc(var(--sidebar-width) * -1);
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:-right-4 {
  right: -1rem;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:left-0 {
  left: 0px;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:-mt-8 {
  margin-top: -2rem;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:hidden {
  display: none;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!size-8 {
  width: 2rem !important;
  height: 2rem !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[--sidebar-width-icon\\] {
  width: var(--sidebar-width-icon);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)\\)\\] {
  width: calc(var(--sidebar-width-icon) + 1rem);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)_\\+2px\\)\\] {
  width: calc(var(--sidebar-width-icon) + 1rem + 2px);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:w-0 {
  width: 0px;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:overflow-hidden {
  overflow: hidden;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:rounded-lg {
  border-radius: var(--radius);
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border {
  border-width: 1px;
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:border-r {
  border-right-width: 1px;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:border-l {
  border-left-width: 1px;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border-sidebar-border {
  border-color: hsl(var(--sidebar-border));
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!p-0 {
  padding: 0px !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!p-2 {
  padding: 0.5rem !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:opacity-0 {
  opacity: 0;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:after\\:left-full::after {
  content: var(--tw-content);
  left: 100%;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:hover\\:bg-sidebar:hover {
  background-color: hsl(var(--sidebar-background));
}

.peer\\/menu-button[data-size="default"] ~ .peer-data-\\[size\\=default\\]\\/menu-button\\:top-1\\.5 {
  top: 0.375rem;
}

.peer\\/menu-button[data-size="lg"] ~ .peer-data-\\[size\\=lg\\]\\/menu-button\\:top-2\\.5 {
  top: 0.625rem;
}

.peer\\/menu-button[data-size="sm"] ~ .peer-data-\\[size\\=sm\\]\\/menu-button\\:top-1 {
  top: 0.25rem;
}

.peer[data-variant="inset"] ~ .peer-data-\\[variant\\=inset\\]\\:min-h-\\[calc\\(100svh-theme\\(spacing\\.4\\)\\)\\] {
  min-height: calc(100svh - 1rem);
}

.peer[data-state="open"] ~ .peer-data-\\[state\\=open\\]\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer\\/menu-button[data-active="true"] ~ .peer-data-\\[active\\=true\\]\\/menu-button\\:text-sidebar-accent-foreground {
  color: hsl(var(--sidebar-accent-foreground));
}

@supports (backdrop-filter: var(--tw)) {

  .supports-\\[backdrop-filter\\]\\:bg-background\\/60 {
    background-color: hsl(var(--background) / 0.6);
  }
}

.dark\\:-rotate-90:is(.dark *) {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dark\\:rotate-0:is(.dark *) {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dark\\:scale-0:is(.dark *) {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dark\\:scale-100:is(.dark *) {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dark\\:divide-amber-900\\/30:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(120 53 15 / 0.3);
}

.dark\\:divide-rose-900\\/30:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(136 19 55 / 0.3);
}

.dark\\:border-amber-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-800\\/40:is(.dark *) {
  border-color: rgb(146 64 14 / 0.4);
}

.dark\\:border-amber-800\\/60:is(.dark *) {
  border-color: rgb(146 64 14 / 0.6);
}

.dark\\:border-amber-900\\/50:is(.dark *) {
  border-color: rgb(120 53 15 / 0.5);
}

.dark\\:border-blue-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.dark\\:border-blue-500\\/30:is(.dark *) {
  border-color: rgb(59 130 246 / 0.3);
}

.dark\\:border-blue-600\\/50:is(.dark *) {
  border-color: rgb(37 99 235 / 0.5);
}

.dark\\:border-blue-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}

.dark\\:border-blue-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity, 1));
}

.dark\\:border-border\\/40:is(.dark *) {
  border-color: hsl(var(--border) / 0.4);
}

.dark\\:border-destructive:is(.dark *) {
  border-color: hsl(var(--destructive));
}

.dark\\:border-gray-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-700\\/50:is(.dark *) {
  border-color: rgb(55 65 81 / 0.5);
}

.dark\\:border-gray-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity, 1));
}

.dark\\:border-indigo-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / var(--tw-border-opacity, 1));
}

.dark\\:border-indigo-800\\/50:is(.dark *) {
  border-color: rgb(55 48 163 / 0.5);
}

.dark\\:border-orange-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(154 52 18 / var(--tw-border-opacity, 1));
}

.dark\\:border-orange-800\\/50:is(.dark *) {
  border-color: rgb(154 52 18 / 0.5);
}

.dark\\:border-purple-500\\/30:is(.dark *) {
  border-color: rgb(168 85 247 / 0.3);
}

.dark\\:border-purple-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(126 34 206 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-900:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-900\\/50:is(.dark *) {
  border-color: rgb(127 29 29 / 0.5);
}

.dark\\:border-rose-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / var(--tw-border-opacity, 1));
}

.dark\\:border-sky-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity, 1));
}

.dark\\:border-sky-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(7 89 133 / var(--tw-border-opacity, 1));
}

.dark\\:border-slate-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}

.dark\\:border-slate-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}

.dark\\:border-slate-700\\/30:is(.dark *) {
  border-color: rgb(51 65 85 / 0.3);
}

.dark\\:border-slate-700\\/50:is(.dark *) {
  border-color: rgb(51 65 85 / 0.5);
}

.dark\\:border-slate-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}

.dark\\:border-violet-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(109 40 217 / var(--tw-border-opacity, 1));
}

.dark\\:border-white:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.dark\\:border-white\\/10:is(.dark *) {
  border-color: rgb(255 255 255 / 0.1);
}

.dark\\:border-white\\/20:is(.dark *) {
  border-color: rgb(255 255 255 / 0.2);
}

.dark\\:border-white\\/30:is(.dark *) {
  border-color: rgb(255 255 255 / 0.3);
}

.dark\\:border-white\\/40:is(.dark *) {
  border-color: rgb(255 255 255 / 0.4);
}

.dark\\:border-yellow-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}

.dark\\:border-yellow-700\\/50:is(.dark *) {
  border-color: rgb(161 98 7 / 0.5);
}

.dark\\:border-yellow-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(133 77 14 / var(--tw-border-opacity, 1));
}

.dark\\:border-yellow-800\\/50:is(.dark *) {
  border-color: rgb(133 77 14 / 0.5);
}

.dark\\:bg-accent\\/60:is(.dark *) {
  background-color: hsl(var(--accent) / 0.6);
}

.dark\\:bg-accent\\/80:is(.dark *) {
  background-color: hsl(var(--accent) / 0.8);
}

.dark\\:bg-amber-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(120 53 15 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-amber-900\\/20:is(.dark *) {
  background-color: rgb(120 53 15 / 0.2);
}

.dark\\:bg-amber-900\\/30:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}

.dark\\:bg-amber-900\\/40:is(.dark *) {
  background-color: rgb(120 53 15 / 0.4);
}

.dark\\:bg-amber-900\\/50:is(.dark *) {
  background-color: rgb(120 53 15 / 0.5);
}

.dark\\:bg-amber-950\\/15:is(.dark *) {
  background-color: rgb(69 26 3 / 0.15);
}

.dark\\:bg-amber-950\\/30:is(.dark *) {
  background-color: rgb(69 26 3 / 0.3);
}

.dark\\:bg-amber-950\\/40:is(.dark *) {
  background-color: rgb(69 26 3 / 0.4);
}

.dark\\:bg-amber-950\\/50:is(.dark *) {
  background-color: rgb(69 26 3 / 0.5);
}

.dark\\:bg-black\\/40:is(.dark *) {
  background-color: rgb(0 0 0 / 0.4);
}

.dark\\:bg-black\\/5:is(.dark *) {
  background-color: rgb(0 0 0 / 0.05);
}

.dark\\:bg-black\\/50:is(.dark *) {
  background-color: rgb(0 0 0 / 0.5);
}

.dark\\:bg-black\\/60:is(.dark *) {
  background-color: rgb(0 0 0 / 0.6);
}

.dark\\:bg-black\\/70:is(.dark *) {
  background-color: rgb(0 0 0 / 0.7);
}

.dark\\:bg-blue-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-900\\/10:is(.dark *) {
  background-color: rgb(30 58 138 / 0.1);
}

.dark\\:bg-blue-900\\/20:is(.dark *) {
  background-color: rgb(30 58 138 / 0.2);
}

.dark\\:bg-blue-900\\/30:is(.dark *) {
  background-color: rgb(30 58 138 / 0.3);
}

.dark\\:bg-blue-900\\/50:is(.dark *) {
  background-color: rgb(30 58 138 / 0.5);
}

.dark\\:bg-blue-950\\/20:is(.dark *) {
  background-color: rgb(23 37 84 / 0.2);
}

.dark\\:bg-card\\/90:is(.dark *) {
  background-color: hsl(var(--card) / 0.9);
}

.dark\\:bg-emerald-900\\/30:is(.dark *) {
  background-color: rgb(6 78 59 / 0.3);
}

.dark\\:bg-emerald-900\\/40:is(.dark *) {
  background-color: rgb(6 78 59 / 0.4);
}

.dark\\:bg-emerald-900\\/50:is(.dark *) {
  background-color: rgb(6 78 59 / 0.5);
}

.dark\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800\\/10:is(.dark *) {
  background-color: rgb(31 41 55 / 0.1);
}

.dark\\:bg-gray-800\\/50:is(.dark *) {
  background-color: rgb(31 41 55 / 0.5);
}

.dark\\:bg-gray-800\\/70:is(.dark *) {
  background-color: rgb(31 41 55 / 0.7);
}

.dark\\:bg-gray-800\\/80:is(.dark *) {
  background-color: rgb(31 41 55 / 0.8);
}

.dark\\:bg-gray-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-900\\/40:is(.dark *) {
  background-color: rgb(17 24 39 / 0.4);
}

.dark\\:bg-gray-900\\/50:is(.dark *) {
  background-color: rgb(17 24 39 / 0.5);
}

.dark\\:bg-gray-900\\/90:is(.dark *) {
  background-color: rgb(17 24 39 / 0.9);
}

.dark\\:bg-gray-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-900\\/20:is(.dark *) {
  background-color: rgb(20 83 45 / 0.2);
}

.dark\\:bg-green-900\\/30:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}

.dark\\:bg-green-950\\/20:is(.dark *) {
  background-color: rgb(5 46 22 / 0.2);
}

.dark\\:bg-indigo-400:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-900\\/30:is(.dark *) {
  background-color: rgb(49 46 129 / 0.3);
}

.dark\\:bg-indigo-900\\/40:is(.dark *) {
  background-color: rgb(49 46 129 / 0.4);
}

.dark\\:bg-indigo-900\\/50:is(.dark *) {
  background-color: rgb(49 46 129 / 0.5);
}

.dark\\:bg-indigo-900\\/60:is(.dark *) {
  background-color: rgb(49 46 129 / 0.6);
}

.dark\\:bg-muted\\/30:is(.dark *) {
  background-color: hsl(var(--muted) / 0.3);
}

.dark\\:bg-orange-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-orange-900\\/30:is(.dark *) {
  background-color: rgb(124 45 18 / 0.3);
}

.dark\\:bg-orange-950\\/30:is(.dark *) {
  background-color: rgb(67 20 7 / 0.3);
}

.dark\\:bg-purple-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-800\\/40:is(.dark *) {
  background-color: rgb(107 33 168 / 0.4);
}

.dark\\:bg-purple-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-900\\/10:is(.dark *) {
  background-color: rgb(88 28 135 / 0.1);
}

.dark\\:bg-purple-900\\/30:is(.dark *) {
  background-color: rgb(88 28 135 / 0.3);
}

.dark\\:bg-purple-900\\/40:is(.dark *) {
  background-color: rgb(88 28 135 / 0.4);
}

.dark\\:bg-purple-950\\/10:is(.dark *) {
  background-color: rgb(59 7 100 / 0.1);
}

.dark\\:bg-red-900\\/20:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}

.dark\\:bg-red-900\\/30:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}

.dark\\:bg-red-900\\/40:is(.dark *) {
  background-color: rgb(127 29 29 / 0.4);
}

.dark\\:bg-red-900\\/50:is(.dark *) {
  background-color: rgb(127 29 29 / 0.5);
}

.dark\\:bg-rose-900\\/20:is(.dark *) {
  background-color: rgb(136 19 55 / 0.2);
}

.dark\\:bg-rose-900\\/40:is(.dark *) {
  background-color: rgb(136 19 55 / 0.4);
}

.dark\\:bg-sky-500\\/30:is(.dark *) {
  background-color: rgb(14 165 233 / 0.3);
}

.dark\\:bg-sky-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(7 89 133 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-sky-900\\/10:is(.dark *) {
  background-color: rgb(12 74 110 / 0.1);
}

.dark\\:bg-sky-900\\/30:is(.dark *) {
  background-color: rgb(12 74 110 / 0.3);
}

.dark\\:bg-sky-900\\/40:is(.dark *) {
  background-color: rgb(12 74 110 / 0.4);
}

.dark\\:bg-sky-900\\/50:is(.dark *) {
  background-color: rgb(12 74 110 / 0.5);
}

.dark\\:bg-slate-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-800\\/10:is(.dark *) {
  background-color: rgb(30 41 59 / 0.1);
}

.dark\\:bg-slate-800\\/30:is(.dark *) {
  background-color: rgb(30 41 59 / 0.3);
}

.dark\\:bg-slate-800\\/50:is(.dark *) {
  background-color: rgb(30 41 59 / 0.5);
}

.dark\\:bg-slate-800\\/80:is(.dark *) {
  background-color: rgb(30 41 59 / 0.8);
}

.dark\\:bg-slate-800\\/90:is(.dark *) {
  background-color: rgb(30 41 59 / 0.9);
}

.dark\\:bg-slate-900\\/10:is(.dark *) {
  background-color: rgb(15 23 42 / 0.1);
}

.dark\\:bg-slate-900\\/50:is(.dark *) {
  background-color: rgb(15 23 42 / 0.5);
}

.dark\\:bg-slate-900\\/90:is(.dark *) {
  background-color: rgb(15 23 42 / 0.9);
}

.dark\\:bg-yellow-800\\/30:is(.dark *) {
  background-color: rgb(133 77 14 / 0.3);
}

.dark\\:bg-yellow-900\\/20:is(.dark *) {
  background-color: rgb(113 63 18 / 0.2);
}

.dark\\:bg-yellow-900\\/30:is(.dark *) {
  background-color: rgb(113 63 18 / 0.3);
}

.dark\\:bg-yellow-950\\/20:is(.dark *) {
  background-color: rgb(66 32 6 / 0.2);
}

.dark\\:bg-zinc-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity, 1));
}

.dark\\:from-amber-500:is(.dark *) {
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-700:is(.dark *) {
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-800:is(.dark *) {
  --tw-gradient-from: #1e40af var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 64 175 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(30 58 138 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-emerald-700:is(.dark *) {
  --tw-gradient-from: #047857 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(4 120 87 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-green-800:is(.dark *) {
  --tw-gradient-from: #166534 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 101 52 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-orange-600:is(.dark *) {
  --tw-gradient-from: #ea580c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 88 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(88 28 135 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-zinc-800:is(.dark *) {
  --tw-gradient-from: #27272a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(39 39 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:to-cyan-600:is(.dark *) {
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}

.dark\\:to-emerald-800:is(.dark *) {
  --tw-gradient-to: #065f46 var(--tw-gradient-to-position);
}

.dark\\:to-orange-600:is(.dark *) {
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}

.dark\\:to-pink-600:is(.dark *) {
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}

.dark\\:to-pink-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(131 24 67 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-purple-800:is(.dark *) {
  --tw-gradient-to: #6b21a8 var(--tw-gradient-to-position);
}

.dark\\:to-purple-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(88 28 135 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-teal-600:is(.dark *) {
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}

.dark\\:to-zinc-600:is(.dark *) {
  --tw-gradient-to: #52525b var(--tw-gradient-to-position);
}

.dark\\:text-accent-foreground:is(.dark *) {
  color: hsl(var(--accent-foreground));
}

.dark\\:text-amber-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-200\\/90:is(.dark *) {
  color: rgb(253 230 138 / 0.9);
}

.dark\\:text-amber-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400\\/40:is(.dark *) {
  color: rgb(251 191 36 / 0.4);
}

.dark\\:text-blue-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

.dark\\:text-fuchsia-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-muted-foreground:is(.dark *) {
  color: hsl(var(--muted-foreground));
}

.dark\\:text-orange-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}

.dark\\:text-orange-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}

.dark\\:text-sky-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(224 242 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-sky-100\\/30:is(.dark *) {
  color: rgb(224 242 254 / 0.3);
}

.dark\\:text-sky-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(186 230 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-sky-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-sky-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-sky-50:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(240 249 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-400\\/60:is(.dark *) {
  color: rgb(250 204 21 / 0.6);
}

.dark\\:text-yellow-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-500\\/70:is(.dark *) {
  color: rgb(234 179 8 / 0.7);
}

.dark\\:placeholder-slate-300:is(.dark *)::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(203 213 225 / var(--tw-placeholder-opacity, 1));
}

.dark\\:placeholder-slate-300:is(.dark *)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(203 213 225 / var(--tw-placeholder-opacity, 1));
}

.dark\\:ring-green-600:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 163 74 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-ring:is(.dark *) {
  --tw-ring-color: hsl(var(--ring));
}

.dark\\:ring-sky-500:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 165 233 / var(--tw-ring-opacity, 1));
}

.dark\\:focus-within\\:border-cyan-400:focus-within:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-blue-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-blue-700:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-indigo-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-indigo-700:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-purple-600:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:bg-amber-800\\/40:hover:is(.dark *) {
  background-color: rgb(146 64 14 / 0.4);
}

.dark\\:hover\\:bg-amber-900\\/10:hover:is(.dark *) {
  background-color: rgb(120 53 15 / 0.1);
}

.dark\\:hover\\:bg-amber-900\\/50:hover:is(.dark *) {
  background-color: rgb(120 53 15 / 0.5);
}

.dark\\:hover\\:bg-amber-950\\/30:hover:is(.dark *) {
  background-color: rgb(69 26 3 / 0.3);
}

.dark\\:hover\\:bg-amber-950\\/40:hover:is(.dark *) {
  background-color: rgb(69 26 3 / 0.4);
}

.dark\\:hover\\:bg-black\\/10:hover:is(.dark *) {
  background-color: rgb(0 0 0 / 0.1);
}

.dark\\:hover\\:bg-blue-500:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-blue-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-blue-800\\/20:hover:is(.dark *) {
  background-color: rgb(30 64 175 / 0.2);
}

.dark\\:hover\\:bg-blue-900\\/20:hover:is(.dark *) {
  background-color: rgb(30 58 138 / 0.2);
}

.dark\\:hover\\:bg-blue-900\\/30:hover:is(.dark *) {
  background-color: rgb(30 58 138 / 0.3);
}

.dark\\:hover\\:bg-blue-950\\/20:hover:is(.dark *) {
  background-color: rgb(23 37 84 / 0.2);
}

.dark\\:hover\\:bg-blue-950\\/30:hover:is(.dark *) {
  background-color: rgb(23 37 84 / 0.3);
}

.dark\\:hover\\:bg-emerald-900\\/30:hover:is(.dark *) {
  background-color: rgb(6 78 59 / 0.3);
}

.dark\\:hover\\:bg-emerald-950\\/30:hover:is(.dark *) {
  background-color: rgb(2 44 34 / 0.3);
}

.dark\\:hover\\:bg-gray-100:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-800\\/50:hover:is(.dark *) {
  background-color: rgb(31 41 55 / 0.5);
}

.dark\\:hover\\:bg-green-500:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-green-900\\/30:hover:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}

.dark\\:hover\\:bg-green-950\\/30:hover:is(.dark *) {
  background-color: rgb(5 46 22 / 0.3);
}

.dark\\:hover\\:bg-indigo-900\\/20:hover:is(.dark *) {
  background-color: rgb(49 46 129 / 0.2);
}

.dark\\:hover\\:bg-indigo-900\\/30:hover:is(.dark *) {
  background-color: rgb(49 46 129 / 0.3);
}

.dark\\:hover\\:bg-indigo-900\\/50:hover:is(.dark *) {
  background-color: rgb(49 46 129 / 0.5);
}

.dark\\:hover\\:bg-indigo-950\\/30:hover:is(.dark *) {
  background-color: rgb(30 27 75 / 0.3);
}

.dark\\:hover\\:bg-orange-500:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-orange-900\\/30:hover:is(.dark *) {
  background-color: rgb(124 45 18 / 0.3);
}

.dark\\:hover\\:bg-orange-950\\/30:hover:is(.dark *) {
  background-color: rgb(67 20 7 / 0.3);
}

.dark\\:hover\\:bg-pink-950\\/30:hover:is(.dark *) {
  background-color: rgb(80 7 36 / 0.3);
}

.dark\\:hover\\:bg-purple-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-purple-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 33 168 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-purple-900\\/20:hover:is(.dark *) {
  background-color: rgb(88 28 135 / 0.2);
}

.dark\\:hover\\:bg-red-900\\/50:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.5);
}

.dark\\:hover\\:bg-red-900\\/60:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.6);
}

.dark\\:hover\\:bg-red-950\\/30:hover:is(.dark *) {
  background-color: rgb(69 10 10 / 0.3);
}

.dark\\:hover\\:bg-red-950\\/50:hover:is(.dark *) {
  background-color: rgb(69 10 10 / 0.5);
}

.dark\\:hover\\:bg-rose-900\\/10:hover:is(.dark *) {
  background-color: rgb(136 19 55 / 0.1);
}

.dark\\:hover\\:bg-sky-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-sky-900\\/40:hover:is(.dark *) {
  background-color: rgb(12 74 110 / 0.4);
}

.dark\\:hover\\:bg-sky-950\\/30:hover:is(.dark *) {
  background-color: rgb(8 47 73 / 0.3);
}

.dark\\:hover\\:bg-slate-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-slate-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-slate-700\\/50:hover:is(.dark *) {
  background-color: rgb(51 65 85 / 0.5);
}

.dark\\:hover\\:bg-slate-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-violet-950\\/30:hover:is(.dark *) {
  background-color: rgb(46 16 101 / 0.3);
}

.dark\\:hover\\:bg-white\\/10:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:hover\\:bg-yellow-800\\/50:hover:is(.dark *) {
  background-color: rgb(133 77 14 / 0.5);
}

.dark\\:hover\\:bg-yellow-900\\/40:hover:is(.dark *) {
  background-color: rgb(113 63 18 / 0.4);
}

.dark\\:hover\\:from-blue-700:hover:is(.dark *) {
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:hover\\:to-purple-700:hover:is(.dark *) {
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}

.dark\\:hover\\:text-blue-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-gray-200:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-gray-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-indigo-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-indigo-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-red-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-sky-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-slate-200:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-yellow-200:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity, 1));
}

.dark\\:focus\\:border-indigo-400:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:bg-gray-800:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:focus\\:bg-red-950\\/20:focus:is(.dark *) {
  background-color: rgb(69 10 10 / 0.2);
}

.group:hover .dark\\:group-hover\\:bg-gray-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-indigo-900\\/50:is(.dark *) {
  background-color: rgb(49 46 129 / 0.5);
}

.group\\/row:hover .dark\\:group-hover\\/row\\:text-sky-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-indigo-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

@media not all and (min-width: 1024px) {

  .max-lg\\:h-auto {
    height: auto;
  }
}

@media not all and (min-width: 768px) {

  .max-md\\:\\!grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
}

@media (min-width: 640px) {

  .sm\\:bottom-0 {
    bottom: 0px;
  }

  .sm\\:bottom-6 {
    bottom: 1.5rem;
  }

  .sm\\:left-6 {
    left: 1.5rem;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:right-6 {
    right: 1.5rem;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:mr-1 {
    margin-right: 0.25rem;
  }

  .sm\\:mr-1\\.5 {
    margin-right: 0.375rem;
  }

  .sm\\:mr-2 {
    margin-right: 0.5rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:mt-3 {
    margin-top: 0.75rem;
  }

  .sm\\:mt-5 {
    margin-top: 1.25rem;
  }

  .sm\\:mt-6 {
    margin-top: 1.5rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline-block {
    display: inline-block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:grid {
    display: grid;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-12 {
    height: 3rem;
  }

  .sm\\:h-16 {
    height: 4rem;
  }

  .sm\\:h-5 {
    height: 1.25rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-7 {
    height: 1.75rem;
  }

  .sm\\:h-8 {
    height: 2rem;
  }

  .sm\\:h-9 {
    height: 2.25rem;
  }

  .sm\\:h-\\[56px\\] {
    height: 56px;
  }

  .sm\\:h-\\[calc\\(100vh-80px\\)\\] {
    height: calc(100vh - 80px);
  }

  .sm\\:min-h-\\[56px\\] {
    min-height: 56px;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-12 {
    width: 3rem;
  }

  .sm\\:w-16 {
    width: 4rem;
  }

  .sm\\:w-5 {
    width: 1.25rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-7 {
    width: 1.75rem;
  }

  .sm\\:w-8 {
    width: 2rem;
  }

  .sm\\:w-9 {
    width: 2.25rem;
  }

  .sm\\:w-\\[400px\\] {
    width: 400px;
  }

  .sm\\:w-\\[56px\\] {
    width: 56px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:max-w-2xl {
    max-width: 42rem;
  }

  .sm\\:max-w-3xl {
    max-width: 48rem;
  }

  .sm\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .sm\\:max-w-\\[425px\\] {
    max-width: 425px;
  }

  .sm\\:max-w-\\[600px\\] {
    max-width: 600px;
  }

  .sm\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .sm\\:max-w-\\[800px\\] {
    max-width: 800px;
  }

  .sm\\:max-w-\\[900px\\] {
    max-width: 900px;
  }

  .sm\\:max-w-lg {
    max-width: 32rem;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:flex-none {
    flex: none;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-2xl {
    border-radius: 1rem;
  }

  .sm\\:rounded-lg {
    border-radius: var(--radius);
  }

  .sm\\:p-2 {
    padding: 0.5rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .sm\\:pt-0\\.5 {
    padding-top: 0.125rem;
  }

  .sm\\:pt-20 {
    padding-top: 5rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-right {
    text-align: right;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"] {
    --tw-enter-translate-y: 100%;
  }
}

@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:relative {
    position: relative;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:mb-4 {
    margin-bottom: 1rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:ml-1\\.5 {
    margin-left: 0.375rem;
  }

  .md\\:ml-auto {
    margin-left: auto;
  }

  .md\\:mr-2 {
    margin-right: 0.5rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:aspect-auto {
    aspect-ratio: auto;
  }

  .md\\:aspect-square {
    aspect-ratio: 1 / 1;
  }

  .md\\:h-10 {
    height: 2.5rem;
  }

  .md\\:h-20 {
    height: 5rem;
  }

  .md\\:h-3 {
    height: 0.75rem;
  }

  .md\\:h-4 {
    height: 1rem;
  }

  .md\\:h-40 {
    height: 10rem;
  }

  .md\\:h-5 {
    height: 1.25rem;
  }

  .md\\:h-6 {
    height: 1.5rem;
  }

  .md\\:h-64 {
    height: 16rem;
  }

  .md\\:h-9 {
    height: 2.25rem;
  }

  .md\\:h-96 {
    height: 24rem;
  }

  .md\\:max-h-\\[90vh\\] {
    max-height: 90vh;
  }

  .md\\:min-h-0 {
    min-height: 0px;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-20 {
    width: 5rem;
  }

  .md\\:w-3 {
    width: 0.75rem;
  }

  .md\\:w-4 {
    width: 1rem;
  }

  .md\\:w-40 {
    width: 10rem;
  }

  .md\\:w-5 {
    width: 1.25rem;
  }

  .md\\:w-6 {
    width: 1.5rem;
  }

  .md\\:w-9 {
    width: 2.25rem;
  }

  .md\\:w-\\[450px\\] {
    width: 450px;
  }

  .md\\:w-\\[80vw\\] {
    width: 80vw;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\] {
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:min-w-0 {
    min-width: 0px;
  }

  .md\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .md\\:max-w-\\[90vw\\] {
    max-width: 90vw;
  }

  .md\\:flex-1 {
    flex: 1 1 0%;
  }

  .md\\:basis-auto {
    flex-basis: auto;
  }

  .md\\:cursor-grab {
    cursor: grab;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[1fr_240px\\] {
    grid-template-columns: 1fr 240px;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .md\\:border {
    border-width: 1px;
  }

  .md\\:border-l {
    border-left-width: 1px;
  }

  .md\\:border-l-0 {
    border-left-width: 0px;
  }

  .md\\:border-t-0 {
    border-top-width: 0px;
  }

  .md\\:bg-muted\\/40 {
    background-color: hsl(var(--muted) / 0.4);
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }

  .md\\:p-3 {
    padding: 0.75rem;
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:pb-0 {
    padding-bottom: 0px;
  }

  .md\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:opacity-0 {
    opacity: 0;
  }

  .md\\:shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .md\\:backdrop-blur-none {
    --tw-backdrop-blur:  ;
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  }

  .after\\:md\\:hidden::after {
    content: var(--tw-content);
    display: none;
  }

  .md\\:active\\:cursor-grabbing:active {
    cursor: grabbing;
  }

  .group:hover .md\\:group-hover\\:opacity-100 {
    opacity: 1;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:m-2 {
    margin: 0.5rem;
  }

  .peer[data-state="collapsed"][data-variant="inset"] ~ .md\\:peer-data-\\[state\\=collapsed\\]\\:peer-data-\\[variant\\=inset\\]\\:ml-2 {
    margin-left: 0.5rem;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:ml-0 {
    margin-left: 0px;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 1024px) {

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:inline {
    display: inline;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:aspect-auto {
    aspect-ratio: auto;
  }

  .lg\\:h-32 {
    height: 8rem;
  }

  .lg\\:h-\\[calc\\(100vh-4rem\\)\\] {
    height: calc(100vh - 4rem);
  }

  .lg\\:h-full {
    height: 100%;
  }

  .lg\\:max-h-full {
    max-height: 100%;
  }

  .lg\\:min-h-0 {
    min-height: 0px;
  }

  .lg\\:w-32 {
    width: 8rem;
  }

  .lg\\:w-\\[400px\\] {
    width: 400px;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1fr_380px\\] {
    grid-template-columns: 1fr 380px;
  }

  .lg\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .lg\\:rounded-lg {
    border-radius: var(--radius);
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

@media (orientation: landscape) {

  .landscape\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .landscape\\:block {
    display: block;
  }

  .landscape\\:flex {
    display: flex;
  }

  .landscape\\:hidden {
    display: none;
  }

  .landscape\\:h-16 {
    height: 4rem;
  }

  .landscape\\:h-full {
    height: 100%;
  }

  .landscape\\:w-16 {
    width: 4rem;
  }

  .landscape\\:overflow-y-auto {
    overflow-y: auto;
  }

  .landscape\\:p-0 {
    padding: 0px;
  }

  .landscape\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

@media (min-width: 1024px) {

  @media (orientation: landscape) {

    .lg\\:landscape\\:m-2 {
      margin: 0.5rem;
    }

    .lg\\:landscape\\:block {
      display: block;
    }

    .lg\\:landscape\\:h-32 {
      height: 8rem;
    }

    .lg\\:landscape\\:w-32 {
      width: 8rem;
    }

    .lg\\:landscape\\:p-0 {
      padding: 0px;
    }
  }
}

.\\[\\&\\:fullscreen\\]\\:h-screen:fullscreen {
  height: 100vh;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]) {
  background-color: hsl(var(--accent));
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside) {
  background-color: hsl(var(--accent) / 0.5);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
  padding-right: 0px;
}

.\\[\\&\\>\\*\\:first-child\\]\\:mt-0>*:first-child {
  margin-top: 0px;
}

.\\[\\&\\>\\*\\:last-child\\]\\:mb-0>*:last-child {
  margin-bottom: 0px;
}

.\\[\\&\\>\\*\\]\\:h-full>* {
  height: 100%;
}

.\\[\\&\\>\\*\\]\\:border-0>* {
  border-width: 0px;
}

.\\[\\&\\>button\\]\\:hidden>button {
  display: none;
}

.\\[\\&\\>span\\:last-child\\]\\:truncate>span:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.\\[\\&\\>span\\]\\:line-clamp-1>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div {
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>svg\\]\\:absolute>svg {
  position: absolute;
}

.\\[\\&\\>svg\\]\\:left-4>svg {
  left: 1rem;
}

.\\[\\&\\>svg\\]\\:top-4>svg {
  top: 1rem;
}

.\\[\\&\\>svg\\]\\:size-3\\.5>svg {
  width: 0.875rem;
  height: 0.875rem;
}

.\\[\\&\\>svg\\]\\:size-4>svg {
  width: 1rem;
  height: 1rem;
}

.\\[\\&\\>svg\\]\\:h-2\\.5>svg {
  height: 0.625rem;
}

.\\[\\&\\>svg\\]\\:h-3>svg {
  height: 0.75rem;
}

.\\[\\&\\>svg\\]\\:w-2\\.5>svg {
  width: 0.625rem;
}

.\\[\\&\\>svg\\]\\:w-3>svg {
  width: 0.75rem;
}

.\\[\\&\\>svg\\]\\:shrink-0>svg {
  flex-shrink: 0;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg {
  color: hsl(var(--destructive));
}

.\\[\\&\\>svg\\]\\:text-foreground>svg {
  color: hsl(var(--foreground));
}

.\\[\\&\\>svg\\]\\:text-muted-foreground>svg {
  color: hsl(var(--muted-foreground));
}

.\\[\\&\\>svg\\]\\:text-sidebar-accent-foreground>svg {
  color: hsl(var(--sidebar-accent-foreground));
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~* {
  padding-left: 1.75rem;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
  border-bottom-width: 0px;
}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\.hidden\\]\\:\\!block .hidden {
  display: block !important;
}

.\\[\\&_\\.recharts-cartesian-axis-tick_text\\]\\:fill-muted-foreground .recharts-cartesian-axis-tick text {
  fill: hsl(var(--muted-foreground));
}

.\\[\\&_\\.recharts-cartesian-grid_line\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border\\/50 .recharts-cartesian-grid line[stroke='#ccc'] {
  stroke: hsl(var(--border) / 0.5);
}

.\\[\\&_\\.recharts-curve\\.recharts-tooltip-cursor\\]\\:stroke-border .recharts-curve.recharts-tooltip-cursor {
  stroke: hsl(var(--border));
}

.\\[\\&_\\.recharts-dot\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-dot[stroke='#fff'] {
  stroke: transparent;
}

.\\[\\&_\\.recharts-layer\\]\\:outline-none .recharts-layer {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\.recharts-polar-grid_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-polar-grid [stroke='#ccc'] {
  stroke: hsl(var(--border));
}

.\\[\\&_\\.recharts-radial-bar-background-sector\\]\\:fill-muted .recharts-radial-bar-background-sector {
  fill: hsl(var(--muted));
}

.\\[\\&_\\.recharts-rectangle\\.recharts-tooltip-cursor\\]\\:fill-muted .recharts-rectangle.recharts-tooltip-cursor {
  fill: hsl(var(--muted));
}

.\\[\\&_\\.recharts-reference-line_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-reference-line [stroke='#ccc'] {
  stroke: hsl(var(--border));
}

.\\[\\&_\\.recharts-sector\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-sector[stroke='#fff'] {
  stroke: transparent;
}

.\\[\\&_\\.recharts-sector\\]\\:outline-none .recharts-sector {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\.recharts-surface\\]\\:outline-none .recharts-surface {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
  font-weight: 500;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
  color: hsl(var(--muted-foreground));
}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group] {
  padding-top: 0px;
}

.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg {
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg {
  width: 1.25rem;
}

.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input] {
  height: 3rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg {
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg {
  width: 1.25rem;
}

.\\[\\&_\\[role\\=combobox\\]\\]\\:min-h-8 [role=combobox] {
  min-height: 2rem;
}

.\\[\\&_\\[role\\=combobox\\]\\]\\:px-2 [role=combobox] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[role\\=combobox\\]\\]\\:py-1\\.5 [role=combobox] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[role\\=combobox\\]\\]\\:text-xs [role=combobox] {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_button\\]\\:h-8 button {
  height: 2rem;
}

.\\[\\&_button\\]\\:text-xs button {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_button\\]\\:font-normal button {
  font-weight: 400;
}

.\\[\\&_p\\]\\:leading-relaxed p {
  line-height: 1.625;
}

.\\[\\&_svg\\]\\:pointer-events-none svg {
  pointer-events: none;
}

.\\[\\&_svg\\]\\:size-4 svg {
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0 svg {
  flex-shrink: 0;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b tr {
  border-bottom-width: 1px;
}

[data-side=left][data-collapsible=offcanvas] .\\[\\[data-side\\=left\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-right-2 {
  right: -0.5rem;
}

[data-side=left][data-state=collapsed] .\\[\\[data-side\\=left\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-e-resize {
  cursor: e-resize;
}

[data-side=left] .\\[\\[data-side\\=left\\]_\\&\\]\\:cursor-w-resize {
  cursor: w-resize;
}

[data-side=right][data-collapsible=offcanvas] .\\[\\[data-side\\=right\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-left-2 {
  left: -0.5rem;
}

[data-side=right][data-state=collapsed] .\\[\\[data-side\\=right\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-w-resize {
  cursor: w-resize;
}

[data-side=right] .\\[\\[data-side\\=right\\]_\\&\\]\\:cursor-e-resize {
  cursor: e-resize;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,uBAAc;IAAd,yBAAc;;IAAd,iBAAc;IAAd,8BAAc;IAAd,6BAAc;;IAAd,oBAAc;IAAd,iCAAc;;IAAd,sBAAc;IAAd,8BAAc;IAAd,4BAAc;;IAAd,2BAAc;IAAd,oCAAc;;IAAd,uBAAc;IAAd,kCAAc;;IAAd,qBAAc;IAAd,6BAAc;IAAd,2BAAc;;IAAd,4BAAc;IAAd,kCAAc;;IAAd,sBAAc;IAAd,qBAAc;IAAd,mBAAc;;IAAd,iBAAc;;IAAd,kCAAc;IAAd,gFAAc;IAAd,iFAAc;IAAd,yFAAc;IAAd,gCAAc;IAAd,iCAAc;IAAd,yDAAc;IAAd,8CAAc;;IAAd,8BAAc;IAAd,oCAAc;IAAd,+BAAc;IAAd,sCAAc;IAAd,gCAAc;IAAd,yCAAc;IAAd,6BAAc;IAAd,iCAAc;;IAAd,oDAAc;IAAd,iCAAc;IAAd,4FAAc;IAAd,4BAAc;IAAd,uBAAc;IAAd,6BAAc;IAAd,qBAAc;IAAd,2BAAc;EAAA;;EAAd;IAAA,8CAAc;IAAd,qBAAc;IAAd,sBAAc;;IAAd,uDAAc;IAAd,eAAc;IAAd,4CAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,8BAAc;;IAAd,mBAAc;IAAd,4CAAc;IAAd,8BAAc;;IAAd,6CAAc;IAAd,sBAAc;IAAd,qCAAc;IAAd,8BAAc;IAAd,4BAAc;;IAAd,qBAAc;IAAd,4CAAc;IAAd,gCAAc;;IAAd,iBAAc;IAAd,4BAAc;IAAd,mCAAc;;IAAd,qBAAc;IAAd,6BAAc;IAAd,2BAAc;;IAAd,wBAAc;IAAd,wBAAc;IAAd,kCAAc;;IAAd,kBAAc;IAAd,iBAAc;IAAd,mBAAc;;IAAd,uCAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,uBAAc;IAAd,uBAAc;IAAd,uBAAc;IAAd,4CAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,uBAAc;IAAd,6BAAc;IAAd,uBAAc;IAAd,+CAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,wBAAc;IAAd,2CAAc;IAAd,wBAAc;IAAd,YAAc;;IAAd,gDAAc;IAAd,gFAAc;IAAd,iFAAc;IAAd,sFAAc;IAAd,+BAAc;IAAd,sCAAc;IAAd,yDAAc;IAAd,8CAAc;;IAAd,6BAAc;IAAd,8BAAc;IAAd,8BAAc;IAAd,sCAAc;IAAd,0BAAc;IAAd,qCAAc;IAAd,0BAAc;IAAd,2BAAc;;IAAd,8BAAc;IAAd,iCAAc;IAAd,wCAAc;IAAd,4CAAc;IAAd,uBAAc;IAAd,6BAAc;IAAd,yCAAc;IAAd,2BAAc;IAAd,yCAAc;EAAA;EAAd;EAAA;AAAc;;EAAd;IAAA,YAAc;IAAd,gCAAc;IAAd,yCAAc;IAAd,qBAAc;IAAd,+DAAc;;IAAd;MAAA,WAAc;MAAd,eAAc;MAAd,MAAc;MAAd,qBAAc;MAAd,mBAAc;MAAd,YAAc;MAAd,WAAc;MAAd,mCAAc;MAAd,oBAAc;IAAA;;IAAd;MAAA,WAAc;MAAd,eAAc;MAAd,MAAc;MAAd,YAAc;MAAd,qBAAc;MAAd,mBAAc;MAAd,YAAc;MAAd,gCAAc;MAAd,+DAAc;MAAd,4BAAc;MAAd,2BAAc;MAAd,8BAAc;MAAd,iCAAc;MAAd,sBAAc;MAAd,oBAAc;IAAA;EAAA;;EAAd;IAAA,2GAAc;IAAd,6BAAc;IAAd,gBAAc;IAAd,oCAAc;IAAd,0CAAc;IAAd,kBAAc;IAAd,iBAAc;IAAd,UAAc;IAAd,2DAAc;;IAAd;MAAA,WAAc;MAAd,eAAc;MAAd,MAAc;MAAd,qBAAc;MAAd,mBAAc;MAAd,YAAc;MAAd,8BAAc;MAAd,6BAAc;MAAd,sCAAc;MAAd,0CAAc;MAAd,yBAAc;MAAd,WAAc;MAAd,oBAAc;IAAA;;IAAd;MAAA,2BAAc;MAAd,0BAAc;IAAA;EAAA;AACd;EAAA,sBAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,2BAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,iBAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,4BAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,gCAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,kBAAoB;EAApB,6BAAoB;EAApB,kCAAoB;EAApB,wDAAoB;EAApB,oCAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,oBAAoB;EAApB,0BAAoB;EAApB,sFAAoB;EAApB,kBAAoB;EAApB,wBAAoB;EAApB,qBAAoB;EAApB,2BAAoB;EAApB,wBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,wCAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB,uBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,UAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,sBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,yBAAoB;EAApB,wBAAoB;EAApB,4BAAoB;EAApB,2BAAoB;EAApB,sBAAoB;EAApB,0BAAoB;EAApB,iCAAoB;EAApB,4BAAoB;EAApB,uBAAoB;EAApB,2CAAoB;EAApB,wBAAoB;EAApB,4BAAoB;EAApB,0BAAoB;EAApB,8BAAoB;EAApB,8BAAoB;EAApB,+BAAoB;EAApB,gCAAoB;EAApB,+BAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,kCAAoB;EAApB,6BAAoB;EAApB,iCAAoB;EAApB,wCAAoB;EAApB,mCAAoB;EAApB,2BAAoB;EAApB,qDAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,0CAAoB;EAApB,qCAAoB;EAApB,qCAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,aAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,wBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB,sBAAoB;EAApB,wBAAoB;EAApB,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,aAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,wBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,iBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,uBAAoB;EAApB,gBAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,0BAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,0BAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,4CAAoB;EAApB,oDAAoB;EAApB,4CAAoB;EAApB,8CAAoB;EAApB,4CAAoB;EAApB,oDAAoB;EAApB,kDAAoB;EAApB,wCAAoB;EAApB,gDAAoB;EAApB,8DAAoB;EAApB,oDAAoB;EAApB,0CAAoB;EAApB,0DAAoB;EAApB,4CAAoB;EAApB,oDAAoB;EAApB,gDAAoB;EAApB,wDAAoB;EAApB;AAAoB;AAqRlB,2DAA2D;AAEzD;EAAA,eAAuG;EAAvG,0BAAuG;EAAvG,+BAAuG;EAAvG,+FAAuG;EAAvG,wDAAuG;EAAvG;AAAuG;AAAvG;EAAA,gCAAuG;EAAvG;AAAuG;AAIvG;EAAA;AAAsB;AAGxB,iCAAiC;AAE/B;EAAA,WAAkD;EAAlD,yBAAkD;EAAlD,iBAAkD;EAAlD;AAAkD;AAIlD;EAAA;AAAkB;AAIlB;EAAA,iBAA6D;EAA7D,gCAA6D;EAA7D,kBAA6D;EAA7D,mBAA6D;EAA7D,mBAA6D;EAA7D,sBAA6D;EAA7D,gBAA6D;EAA7D;AAA6D;AAI7D;EAAA,iBAAqC;EAArC,gCAAqC;EAArC,kBAAqC;EAArC,mBAAqC;EAArC,mBAAqC;EAArC;AAAqC;AAIrC;EAAA;AAAkB;AAGpB,mBAAmB;AACnB;;;;IAIE,uBAAuB,EAAE,qDAAqD;EAChF;AAGE;EAAA,mBAAmC;EAAnC,kBAAmC;EAAnC,iBAAmC;EAAnC,iBAAmC;EAAnC;AAAmC;AAInC;EAAA,sBAAkC;EAAlC,mBAAkC;EAAlC,kBAAkC;EAAlC,oBAAkC;EAAlC;AAAkC;AAIlC;EAAA,qBAA8B;EAA9B,gBAA8B;EAA9B;AAA8B;AAI9B;EAAA,qBAAsC;EAAtC,mBAAsC;EAAtC,mBAAsC;EAAtC,oBAAsC;EAAtC;AAAsC;AAGxC,gBAAgB;AAEd;EAAA,mBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAI1B;EAAA,mBAA6B;EAA7B,wBAA6B;EAA7B;AAA6B;AAI7B;EAAA;AAAW;AAGb,gBAAgB;AAEd;EAAA,sBAAmF;EAAnF,mCAAmF;EAAnF,sBAAmF;EAAnF,uBAAmF;EAAnF,qBAAmF;EAAnF,wBAAmF;EAAnF,+GAAmF;EAAnF,mBAAmF;EAAnF,oBAAmF;EAAnF,gBAAmF;EAAnF;AAAmF;AAGrF,mGAAmG;AACnG;;IAEE,aAAa;EACf;AAGE;EAAA,mBAAmE;EAAnE,gBAAmE;EAAnE,4BAAmE;EAAnE,mCAAmE;EAAnE,aAAmE;EAAnE;AAAmE;AAInE;EAAA,6BAAqD;EAArD,YAAqD;EAArD,gBAAqD;EAArD;AAAqD;AAGvD,gBAAgB;AAEd;EAAA,gBAAiD;EAAjD,mBAAiD;EAAjD,sBAAiD;EAAjD,iCAAiD;EAAjD,kBAAiD;EAAjD;AAAiD;AAGnD,eAAe;AAEb;EAAA;AAAW;AAGb,qBAAqB;AAEnB;EAAA,kBAAkC;EAAlC,qBAAkC;EAAlC,qBAAkC;EAAlC;AAAkC;AAGpC,gBAAgB;AAEd;EAAA;AAAgB;AAGlB,oBAAoB;AAElB;EAAA;AAAa;AAOf,sEAAsE;AACtE;IACE,iCAA8B;OAA9B,8BAA8B;IAC9B,qCAAkC;OAAlC,kCAAkC;IAClC,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;EACzB;AAEA,uCAAuC;AACvC;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AAEA,yCAAyC;AACzC,oFAAoF;AAMpF;;;;GAIC;AAcD,gCAAgC;AAChC,qEAAqE;AAEnE;EAAA,wCAAoC;EAApC;AAAoC;AAApC;IAAA,oCAAoC;EAAA;AAnbxC;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,2EAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA,0BAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,wBAAmB;EAAnB,yBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA6OjB;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,qBAAqB;IACrB,YAAY;EACd;AAEA;IACE,aAAa;IACb,sBAAsB;EACxB;AAEA,0BAA0B;AAC1B;IACE,UAAU;IACV,WAAW;EACb;AAEA;IACE,uBAAuB;EACzB;AAEA;IACE,oDAAoD;IACpD,mBAAmB;EACrB;AAEA;IACE,oDAAoD;EACtD;AAEA,sEAAsE;AACtE;IACE,+CAA+C;EACjD;AA/QF;EAAA;AAAmB;;AAEnB,yEAAyE;;AAkYzE,wCAAwC;;AAtYxC;EAAA,4CAubC;EAvbD,oDAubC;EAvbD,4CAubC;EAvbD,8CAubC;EAvbD,4CAubC;EAvbD,oDAubC;EAvbD,kDAubC;EAvbD,wCAubC;EAvbD,gDAubC;EAvbD,8DAubC;EAvbD,oDAubC;EAvbD,0CAubC;EAvbD,0DAubC;EAvbD,4CAubC;EAvbD,oDAubC;EAvbD,gDAubC;EAvbD,wDAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,mBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD,QAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,iDAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kDAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,iBAubC;EAvbD,iBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,0EAubC;EAvbD,oEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,qEAubC;EAvbD;AAubC;;AAvbD;EAAA,0EAubC;EAvbD,oEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,yEAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,2EAubC;EAvbD,qEAubC;EAvbD;AAubC;;AAvbD;EAAA,yEAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,oEAubC;EAvbD;AAubC;;AAvbD;EAAA,0EAubC;EAvbD,oEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,oEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,oEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,gDAubC;EAvbD,6DAubC;EAvbD;AAubC;;AAvbD;EAAA,iDAubC;EAvbD,qDAubC;EAvbD;AAubC;;AAvbD;EAAA,+BAubC;EAvbD,uCAubC;EAvbD;AAubC;;AAvbD;EAAA,+EAubC;EAvbD,mGAubC;EAvbD;AAubC;;AAvbD;EAAA,6EAubC;EAvbD,iGAubC;EAvbD;AAubC;;AAvbD;EAAA,gFAubC;EAvbD,oGAubC;EAvbD;AAubC;;AAvbD;EAAA,wCAubC;EAvbD;AAubC;;AAvbD;EAAA,wCAubC;EAvbD;AAubC;;AAvbD;EAAA,uCAubC;EAvbD;AAubC;;AAvbD;EAAA,yCAubC;EAvbD;AAubC;;AAvbD;EAAA,uCAubC;EAvbD;AAubC;;AAvbD;EAAA,wCAubC;EAvbD;AAubC;;AAvbD;EAAA,2GAubC;EAvbD,yGAubC;EAvbD;AAubC;;AAvbD;EAAA,2GAubC;EAvbD,yGAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,4BAubC;EAvbD;AAubC;;AAxKC;IACE,+CAA+C;EACjD;;AAjRF;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,8BAubC;EAvbD;AAubC;;AAvbD;EAAA,2GAubC;EAvbD,yGAubC;EAvbD;AAubC;;AAvbD;EAAA,2GAubC;EAvbD,yGAubC;EAvbD;AAubC;;AAvbD;EAAA,2GAubC;EAvbD,yGAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAxKC;IACE,+CAA+C;EACjD;;AAjRF;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,8BAubC;EAvbD;AAubC;;AAvbD;EAAA,2GAubC;EAvbD,yGAubC;EAvbD;AAubC;;AAvbD;EAAA,2GAubC;EAvbD,yGAubC;EAvbD;AAubC;;AAvbD;EAAA,2GAubC;EAvbD,yGAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,iBAubC;EAvbD,iBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,eAubC;EAvbD,eAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,iBAubC;EAvbD,iBAubC;EAvbD;AAubC;;AAvbD;;EAAA;IAAA;EAubC;AAAA;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,4BAubC;EAvbD;AAubC;;AAxKC;IACE,+CAA+C;EACjD;;AAjRF;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,+EAubC;EAvbD,mGAubC;EAvbD;AAubC;;AAxKC;IACE,+CAA+C;EACjD;;AAjRF;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,yBAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,yBAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,yBAubC;EAvbD;AAubC;;AAvbD;EAAA,qBAubC;EAvbD;AAubC;;AAvbD;EAAA,qBAubC;EAvbD;AAubC;;AAvbD;EAAA,gDAubC;EAvbD;AAubC;;AAvbD;EAAA,iDAubC;EAvbD;AAubC;;AAvbD;;EAAA;IAAA;EAubC;;EAvbD;IAAA;EAubC;AAAA;;AAvbD;EAAA;AAubC;;AAvbD;;EAAA;IAAA;EAubC;;EAvbD;IAAA;EAubC;AAAA;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD,8BAubC;EAvbD;AAubC;;AAvbD;EAAA,0CAubC;EAvbD,uDAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,qBAubC;EAvbD,yBAubC;EAvbD,2BAubC;EAvbD,yBAubC;EAvbD,0BAubC;EAvbD,+BAubC;EAvbD;AAubC;;AAvbD;EAAA,qBAubC;EAvbD,yBAubC;EAvbD,2BAubC;EAvbD,yBAubC;EAvbD,0BAubC;EAvbD,+BAubC;EAvbD;AAubC;;AAvbD;EAAA,qBAubC;EAvbD,yBAubC;EAvbD,2BAubC;EAvbD,yBAubC;EAvbD,0BAubC;EAvbD,+BAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD,yBAubC;EAvbD,0BAubC;EAvbD,wBAubC;EAvbD,yBAubC;EAvbD,8BAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD,yBAubC;EAvbD,0BAubC;EAvbD,wBAubC;EAvbD,yBAubC;EAvbD,8BAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD,yBAubC;EAvbD,0BAubC;EAvbD,wBAubC;EAvbD,yBAubC;EAvbD,8BAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD,yBAubC;EAvbD,0BAubC;EAvbD,wBAubC;EAvbD,yBAubC;EAvbD,8BAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAxKC;IACE,+CAA+C;EACjD;;AAjRF;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD,qBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,qBAubC;EAvbD;AAubC;;AAvbD;EAAA,mBAubC;EAvbD;AAubC;;AAvbD;EAAA,mBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,0EAubC;EAvbD,8FAubC;EAvbD;AAubC;;AAvbD;EAAA,0BAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,mBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;;EAAA;IAAA;EAubC;AAAA;;AAvbD;EAAA,mBAubC;EAvbD;AAubC;;AAvbD;EAAA,iBAubC;EAvbD;AAubC;;AAvbD;EAAA,eAubC;EAvbD,eAubC;EAvbD;AAubC;;AAvbD;EAAA,eAubC;EAvbD,eAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,oEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,yEAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,kEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,yEAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,kEAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,2BAubC;EAvbD;AAubC;;AAvbD;EAAA,2BAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,4DAubC;EAvbD,mEAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;;EAAA;IAAA;EAubC;AAAA;;AAvbD;;EAAA;IAAA;EAubC;AAAA;;AAvbD;;EAAA;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,uBAubC;IAvbD,sDAubC;IAvbD;EAubC;;EAvbD;IAAA,uBAubC;IAvbD,oDAubC;IAvbD;EAubC;;EAvbD;IAAA,uBAubC;IAvbD,2DAubC;IAvbD;EAubC;;EAvbD;IAAA,uBAubC;IAvbD,4DAubC;IAvbD;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,oBAubC;IAvbD;EAubC;;EAvbD;IAAA,qBAubC;IAvbD;EAubC;;EAvbD;IAAA,kBAubC;IAvbD;EAubC;;EAvbD;IAAA,oBAubC;IAvbD;EAubC;;EAvbD;IAAA,kBAubC;IAvbD;EAubC;;EAvbD;IAAA,mBAubC;IAvbD;EAubC;;EAvbD;IAAA,qBAubC;IAvbD;EAubC;;EAvbD;IAAA,iBAubC;IAvbD;EAubC;;EAvbD;IAAA,mBAubC;IAvbD;EAubC;;EAvbD;IAAA,iBAubC;IAvbD;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,iBAubC;IAvbD;EAubC;;EAvbD;IAAA,mBAubC;IAvbD;EAubC;;EAvbD;IAAA,eAubC;IAvbD;EAubC;;EAvbD;IAAA,mBAubC;IAvbD;EAubC;;EAvbD;IAAA,mBAubC;IAvbD;EAubC;;EAvbD;IAAA,kBAubC;IAvbD;EAubC;;EAvbD;IAAA;EAubC;AAAA;;AAvbD;;EAAA;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,gBAubC;IAvbD;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,uBAubC;IAvbD,+DAubC;IAvbD;EAubC;;EAvbD;IAAA,uBAubC;IAvbD,4DAubC;IAvbD;EAubC;;EAvbD;IAAA,uBAubC;IAvbD,8DAubC;IAvbD;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,oBAubC;IAvbD;EAubC;;EAvbD;IAAA,qBAubC;IAvbD;EAubC;;EAvbD;IAAA,oBAubC;IAvbD;EAubC;;EAvbD;IAAA,mBAubC;IAvbD;EAubC;;EAvbD;IAAA,iBAubC;IAvbD;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,iBAubC;IAvbD;EAubC;;EAvbD;IAAA,eAubC;IAvbD;EAubC;;EAvbD;IAAA,mBAubC;IAvbD;EAubC;;EAvbD;IAAA,mBAubC;IAvbD;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,6EAubC;IAvbD,iGAubC;IAvbD;EAubC;;EAvbD;IAAA,qBAubC;IAvbD;EAubC;;EAvbD;IAAA,0BAubC;IAvbD;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,0EAubC;IAvbD,8FAubC;IAvbD;EAubC;AAAA;;AAvbD;;EAAA;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,oBAubC;IAvbD;EAubC;;EAvbD;IAAA,kBAubC;IAvbD;EAubC;;EAvbD;IAAA,iBAubC;IAvbD;EAubC;;EAvbD;IAAA,mBAubC;IAvbD;EAubC;;EAvbD;IAAA,kBAubC;IAvbD;EAubC;;EAvbD;IAAA,mBAubC;IAvbD;EAubC;;EAvbD;IAAA,kBAubC;IAvbD;EAubC;AAAA;;AAvbD;;EAAA;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;AAAA;;AAvbD;;EAAA;IAAA,oBAubC;IAvbD;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA;EAubC;;EAvbD;IAAA,gBAubC;IAvbD;EAubC;AAAA;;AAvbD;;EAAA;;IAAA;MAAA;IAubC;;IAvbD;MAAA;IAubC;;IAvbD;MAAA;IAubC;;IAvbD;MAAA;IAubC;;IAvbD;MAAA;IAubC;EAAA;AAAA;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,iDAubC;EAvbD;AAubC;;AAvbD;EAAA,kDAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kDAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,gBAubC;EAvbD,uBAubC;EAvbD;AAubC;;AAvbD;EAAA,gBAubC;EAvbD,oBAubC;EAvbD,4BAubC;EAvbD;AAubC;;AAvbD;EAAA,sBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,eAubC;EAvbD;AAubC;;AAvbD;EAAA,WAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA,mBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,8BAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,8BAubC;EAvbD;AAubC;;AAvbD;EAAA,8BAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,qBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,oBAubC;EAvbD;AAubC;;AAvbD;EAAA,qBAubC;EAvbD;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,kBAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA,WAubC;EAvbD;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC;;AAvbD;EAAA;AAubC","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Photo sharing app design system - modern gradients and glass effects */\n\n@layer base {\n  :root {\n    --background: 0 0% 100%;\n    --foreground: 240 10% 15%;\n\n    --card: 0 0% 100%;\n    --card-foreground: 240 10% 15%;\n    --card-glass: 0 0% 100% / 0.8;\n\n    --popover: 0 0% 100%;\n    --popover-foreground: 240 10% 15%;\n\n    --primary: 262 83% 58%;\n    --primary-foreground: 0 0% 98%;\n    --primary-glow: 280 100% 70%;\n\n    --secondary: 240 4.8% 95.9%;\n    --secondary-foreground: 240 5.9% 10%;\n\n    --muted: 240 4.8% 95.9%;\n    --muted-foreground: 240 3.8% 46.1%;\n\n    --accent: 193 76% 59%;\n    --accent-foreground: 0 0% 98%;\n    --accent-glow: 193 100% 70%;\n\n    --destructive: 0 84.2% 60.2%;\n    --destructive-foreground: 0 0% 98%;\n\n    --border: 240 5.9% 90%;\n    --input: 240 5.9% 90%;\n    --ring: 262 83% 58%;\n\n    --radius: 0.75rem;\n\n    /* Photo sharing specific tokens */\n    --gradient-primary: linear-gradient(135deg, hsl(262 83% 58%), hsl(280 100% 70%));\n    --gradient-secondary: linear-gradient(135deg, hsl(193 76% 59%), hsl(262 83% 58%));\n    --gradient-hero: linear-gradient(135deg, hsl(0 0% 100%) 0%, hsl(262 83% 58% / 0.05) 100%);\n    --glass-bg: hsl(0 0% 100% / 0.8);\n    --glass-border: hsl(240 5.9% 90%);\n    --photo-shadow: 0 25px 50px -12px hsl(262 83% 58% / 0.15);\n    --glow-shadow: 0 0 40px hsl(262 83% 58% / 0.2);\n\n    --sidebar-background: 0 0% 98%;\n    --sidebar-foreground: 240 5.3% 26.1%;\n    --sidebar-primary: 240 5.9% 10%;\n    --sidebar-primary-foreground: 0 0% 98%;\n    --sidebar-accent: 240 4.8% 95.9%;\n    --sidebar-accent-foreground: 240 5.9% 10%;\n    --sidebar-border: 220 13% 91%;\n    --sidebar-ring: 217.2 91.2% 59.8%;\n\n    /* Body Background Variables - Light Mode Defaults */\n    --body-bg: hsl(var(--background));\n    --body-bg-gradient: linear-gradient(135deg, hsl(0 0% 100%) 0%, hsl(262 83% 58% / 0.05) 100%);\n    --body-bg-cover: transparent;\n    --body-font-weight: 400;\n    --body-letter-spacing: normal;\n    --body-bg-image: none;\n    --body-bg-image-size: cover;\n  }\n\n  .dark {\n    /* Material Design dark theme base - #121212 */\n    --background: 0 0% 7%;\n    --foreground: 0 0% 95%;\n\n    /* Surface elevation system following Material Design */\n    --card: 0 0% 9%;\n    /* 1dp elevation = base + 5% white overlay */\n    --card-foreground: 0 0% 95%;\n    --card-glass: 0 0% 12% / 0.8;\n    /* Higher elevation surfaces */\n\n    --popover: 0 0% 11%;\n    /* 2dp elevation = base + 7% white overlay */\n    --popover-foreground: 0 0% 95%;\n\n    /* Accessible primary colors for dark theme */\n    --primary: 270 91% 75%;\n    /* Lighter for better accessibility */\n    --primary-foreground: 0 0% 10%;\n    --primary-glow: 280 100% 80%;\n\n    --secondary: 0 0% 15%;\n    /* 3dp elevation = base + 8% white overlay */\n    --secondary-foreground: 0 0% 95%;\n\n    --muted: 0 0% 15%;\n    --muted-foreground: 0 0% 65%;\n    /* Better contrast for muted text */\n\n    --accent: 270 91% 75%;\n    --accent-foreground: 0 0% 10%;\n    --accent-glow: 280 100% 80%;\n\n    --destructive: 0 70% 50%;\n    /* More accessible red */\n    --destructive-foreground: 0 0% 95%;\n\n    --border: 0 0% 15%;\n    --input: 0 0% 15%;\n    --ring: 270 91% 75%;\n\n    /* Material Design elevation surfaces */\n    --surface-1dp: 0 0% 9%;\n    /* Cards, switches */\n    --surface-2dp: 0 0% 11%;\n    /* App bars (resting) */\n    --surface-3dp: 0 0% 12%;\n    /* Refresh indicator, search bar (resting) */\n    --surface-4dp: 0 0% 13%;\n    /* App bars (scrolled) */\n    --surface-6dp: 0 0% 14%;\n    /* FAB (resting), snackbars */\n    --surface-8dp: 0 0% 15%;\n    /* Menus, cards (picked up), switches (thumb) */\n    --surface-12dp: 0 0% 16%;\n    /* FAB (pressed) */\n    --surface-16dp: 0 0% 17%;\n    /* Navigation drawer, modal bottom sheets */\n    --surface-24dp: 0 0% 18%;\n    /* Dialogs */\n\n    /* Photo sharing specific tokens for dark mode */\n    --gradient-primary: linear-gradient(135deg, hsl(270 91% 75%), hsl(280 100% 80%));\n    --gradient-secondary: linear-gradient(135deg, hsl(270 91% 75%), hsl(260 85% 70%));\n    --gradient-hero: linear-gradient(135deg, hsl(0 0% 7%) 0%, hsl(270 91% 75% / 0.1) 100%);\n    --glass-bg: hsl(0 0% 12% / 0.4);\n    --glass-border: hsl(270 91% 75% / 0.2);\n    --photo-shadow: 0 25px 50px -12px hsl(270 91% 75% / 0.25);\n    --glow-shadow: 0 0 40px hsl(270 91% 75% / 0.3);\n\n    --sidebar-background: 0 0% 7%;\n    --sidebar-foreground: 0 0% 95%;\n    --sidebar-primary: 270 91% 75%;\n    --sidebar-primary-foreground: 0 0% 10%;\n    --sidebar-accent: 0 0% 15%;\n    --sidebar-accent-foreground: 0 0% 95%;\n    --sidebar-border: 0 0% 15%;\n    --sidebar-ring: 270 91% 75%;\n\n    /* Body Background Variables */\n    --body-bg: hsl(var(--background));\n    --body-bg-gradient: var(--gradient-hero);\n    --body-bg-cover: url('/home-background.jpg');\n    --body-font-weight: 400;\n    --body-letter-spacing: normal;\n    --body-bg-image: url('/pattern-dark.png');\n    --body-bg-image-size: 140px;\n    /* Adjust as needed for pattern density */\n  }\n}\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n\n  html {\n    height: 100%;\n    background-color: var(--body-bg);\n    background-image: var(--body-bg-gradient);\n    scrollbar-width: thin;\n    scrollbar-color: hsl(var(--muted-foreground) / 0.3) transparent;\n\n    &:before {\n      content: '';\n      position: fixed;\n      top: 0;\n      inset-inline-start: 0;\n      inset-inline-end: 0;\n      height: 100%;\n      z-index: -5;\n      background: var(--body-bg-gradient);\n      pointer-events: none;\n    }\n\n    &:after {\n      content: '';\n      position: fixed;\n      top: 0;\n      height: 100%;\n      inset-inline-start: 0;\n      inset-inline-end: 0;\n      z-index: -10;\n      background-color: var(--body-bg);\n      background-image: var(--body-bg-gradient), var(--body-bg-cover);\n      background-repeat: no-repeat;\n      background-position: center;\n      background-attachment: initial;\n      transition: background .2s linear;\n      background-size: cover;\n      pointer-events: none;\n    }\n  }\n\n  body {\n    /* @apply bg-background text-foreground; - Removing bg-background as it's handled by html/body layers now */\n    @apply text-foreground;\n    background: none;\n    font-weight: var(--body-font-weight);\n    letter-spacing: var(--body-letter-spacing);\n    position: relative;\n    min-height: 100vh;\n    z-index: 1;\n    /* Changed from 9999 to avoid stacking issues with modals */\n\n    &:before {\n      content: \"\";\n      position: fixed;\n      top: 0;\n      inset-inline-start: 0;\n      inset-inline-end: 0;\n      height: 100%;\n      background-attachment: initial;\n      background-color: transparent;\n      background-image: var(--body-bg-image);\n      background-size: var(--body-bg-image-size);\n      background-repeat: repeat;\n      z-index: -5;\n      pointer-events: none;\n    }\n\n    &:not(.app-init) * {\n      transition: none !important;\n      animation: none !important;\n    }\n  }\n}\n\n@layer utilities {\n  .scrollbar-hide {\n    -ms-overflow-style: none;\n    /* Internet Explorer 10+ */\n    scrollbar-width: none;\n    /* Firefox */\n  }\n\n  .scrollbar-hide::-webkit-scrollbar {\n    display: none;\n    /* Safari and Chrome */\n  }\n\n  /* Custom thin scrollbar */\n  .scrollbar-custom::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n\n  .scrollbar-custom::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .scrollbar-custom::-webkit-scrollbar-thumb {\n    background-color: hsl(var(--muted-foreground) / 0.3);\n    border-radius: 20px;\n  }\n\n  .scrollbar-custom::-webkit-scrollbar-thumb:hover {\n    background-color: hsl(var(--muted-foreground) / 0.5);\n  }\n\n  /* Force background transparency in dark mode to show global pattern */\n  .dark .bg-background {\n    background-color: rgba(0, 0, 0, 0.5) !important;\n  }\n}\n\n@layer components {\n\n  /* Ensure links in prose content are clickable and styled */\n  .prose a {\n    @apply text-primary hover:text-primary/80 underline hover:no-underline transition-colors cursor-pointer;\n  }\n\n  .prose a:visited {\n    @apply text-primary/70;\n  }\n\n  /* Enhanced prose table styling */\n  .prose table {\n    @apply w-full border-collapse border border-border;\n  }\n\n  .prose thead {\n    @apply bg-muted/50;\n  }\n\n  .prose th {\n    @apply border border-border px-4 py-2 text-left font-semibold;\n  }\n\n  .prose td {\n    @apply border border-border px-4 py-2;\n  }\n\n  .prose tbody tr:hover {\n    @apply bg-muted/30;\n  }\n\n  /* Heading styles */\n  .prose h1,\n  .prose h2,\n  .prose h3,\n  .prose h4 {\n    scroll-margin-top: 5rem; /* offset for fixed top nav (56px) + breathing room */\n  }\n\n  .prose h1 {\n    @apply text-2xl font-bold mb-4 mt-6;\n  }\n\n  .prose h2 {\n    @apply text-xl font-bold mb-3 mt-5;\n  }\n\n  .prose h3 {\n    @apply font-semibold mb-2 mt-4;\n  }\n\n  .prose h4 {\n    @apply text-lg font-semibold mb-2 mt-3;\n  }\n\n  /* List styles */\n  .prose ul {\n    @apply list-disc pl-6 mb-4;\n  }\n\n  .prose ol {\n    @apply list-decimal pl-6 mb-4;\n  }\n\n  .prose li {\n    @apply mb-1;\n  }\n\n  /* Code blocks */\n  .prose code {\n    @apply bg-muted px-1.5 py-0.5 rounded text-sm font-mono text-foreground font-medium;\n  }\n\n  /* Typography plugin decorates inline code with literal backticks — disable for rendered markdown */\n  .prose :where(code):not(:where(pre code))::before,\n  .prose :where(code):not(:where(pre code))::after {\n    content: none;\n  }\n\n  .prose pre {\n    @apply bg-muted p-4 rounded-lg overflow-x-auto mb-4 text-foreground;\n  }\n\n  .prose pre code {\n    @apply bg-transparent p-0 text-foreground font-normal;\n  }\n\n  /* Blockquotes */\n  .prose blockquote {\n    @apply border-l-4 border-primary pl-4 italic my-4;\n  }\n\n  /* Paragraphs */\n  .prose p {\n    @apply mb-4;\n  }\n\n  /* Horizontal rules */\n  .prose hr {\n    @apply border-t border-border my-6;\n  }\n\n  /* Strong/Bold */\n  .prose strong {\n    @apply font-bold;\n  }\n\n  /* Emphasis/Italic */\n  .prose em {\n    @apply italic;\n  }\n}\n\n/* TikTok-style Video Player Overrides */\n@layer components {\n\n  /* Force Vidstack video to use object-contain for full video display */\n  [data-media-player] video {\n    object-fit: contain !important;\n    object-position: center !important;\n    max-width: 100% !important;\n    max-height: 100% !important;\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  /* Constrain video player to viewport */\n  [data-media-player] {\n    max-width: 100% !important;\n    max-height: 100% !important;\n  }\n\n  /* Email Widget Overrides (Design View) */\n  /* Fix for \"font-size: 0\" hack in email templates causing invisible text in editor */\n  .html-widget-container .long-text {\n    font-size: 12px;\n    /* The inline style from the widget prop will override this if valid */\n  }\n\n  /* \n     Reset email table structure for Editor View \n     - Makes the gray structural background transparent\n     - Allows widgets to take full width of their container in the editor\n  */\n  .html-widget-container .vb-outer {\n    background-color: transparent !important;\n    height: auto !important;\n  }\n\n  .html-widget-container .vb-outer div {\n    max-width: 100% !important;\n  }\n\n  .html-widget-container table {\n    max-width: 100% !important;\n  }\n\n  /* RJSF Textarea Dark Mode Fix */\n  /* Textareas inherit browser defaults which show white in dark mode */\n  textarea {\n    @apply bg-background text-foreground;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
